<template>
  <div class="container-fluid">
    <div class="loading-state" v-if="loading">
      <ProgressSpinner fill="transparent" aria-label="Loading" />
    </div>
    <div class="row mb-5">
      <div class="col-12">
        <ul id="homeTab" class="nav nav-tabs" role="tablist">
          <li class="nav-item" role="presentation">
            <button id="first-home-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#firstHome" type="button"
              role="tab" aria-controls="firstHome" aria-selected="true" @click="backToFirstTab()">
              {{ $t("content.amngroupticket") }}
            </button>
          </li>

          <li class="nav-item" role="presentation">
            <button id="second-home-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#secondHome"
              type="button" role="tab" aria-controls="secondHome" aria-selected="false" @click="backToSecondTab()">
              {{ $t("content.amnalljobs") }}
            </button>
          </li>

          <li class="nav-item" role="presentation">
            <button id="third-home-tab" class="nav-link" data-bs-toggle="tab" data-bs-target="#thirdHome" type="button"
              role="tab" aria-controls="thirdHome" aria-selected="false" :disabled="workcaseDetail === null"
              @click="onClickTab('3')">
              {{ $t("content.amnconfirmtxn") }}
            </button>
          </li>
        </ul>

        <div id="homeTabContent" class="tab-content">
          <div id="firstHome" class="tab-pane fade" role="tabpanel" aria-labelledby="first-home-tab">
            <div class="card mt-2">
              <div class="card-header mb-0">
                <h5>{{ $t("content.amngroupticketsearch") }}</h5>
              </div>

              <div class="card-body pt-0">
                <div class="row mt-2">
                  <div class="col-12 d-flex">
                    <div class="me-3">
                      <material-button color="success" class="float-lg-start float-sm-end mb-3" @click="onOpenQRModal">
                        <i class="material-icons material-symbols-outlined">qr_code_scanners</i>
                        {{ $t("buttons.sscan") }}
                      </material-button>
                      <material-button color="success" class="float-lg-start float-sm-end mb-3" data-bs-toggle="modal"
                        data-bs-target="#qrcodeModal" id="qrModalShow" v-show="false">
                      </material-button>
                    </div>
                    <div class="col-8 me-3">
                      <material-input type="text" v-model="qr_serach" :placeholder="t(`content.amnjobcode`)"
                        @keyup.enter="setResultQRTab1" />
                    </div>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="col-12">
                    <span class="form-label m-0">{{ $t("content.amnselectauto") }}</span>

                    <div class="d-inline-block mx-4">
                      <material-checkbox id="asGroup" v-model="selectGroup" :checked="selectGroup" name="autoSelect"
                        :disabled="selectType" @change="onSelectGroup">
                        {{ $t("content.amnasgroup") }}
                      </material-checkbox>
                    </div>

                    <div class="d-inline-block me-4">
                      <material-checkbox id="asType" v-model="selectType" :checked="selectType" name="autoSelect"
                        :disabled="selectGroup" @change="onSelectType">
                        {{ $t("content.amnastype") }}
                      </material-checkbox>
                    </div>

                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>
                          <th></th>
                          <th>#</th>
                          <th>{{ $t("content.jobId") }}</th>
                          <th>{{ $t("content.trayId") }}</th>
                          <th>{{ $t("content.amndatetime") }}</th>
                          <th>{{ $t("content.tkOwner") }}</th>
                          <th>{{ $t("content.oldname") }}</th>
                          <th>{{ $t("content.refnumber") }}</th>
                          <th>{{ $t("content.payside") }}</th>
                          <th>{{ $t("content.amnbiz") }}</th>
                          <th>{{ $t("content.amnweightvalall") }}</th>
                          <th>{{ $t("content.amnqtyunitall") }}</th>
                          <th>{{ $t("content.amnanalysval") }}</th>
                          <th>{{ $t("content.amnmaxvalall") }}</th>
                          <th>{{ $t("content.amnreceiveprofit") }}</th>
                          <th>{{ $t("content.gpay") }}</th>
                          <th>{{ $t("content.amnlastmaker") }}</th>
                        </tr>
                      </thead>

                      <tbody data-group-index="0">

                        <tr v-for="(row, index) in listQ03" :key="index" :class="row.paySide == 'PAY' && row.migration ? 'bg-redeem'
                          : row.paySide == 'PAY' && !row.migration ? 'bg-payment'
                            : row.paySide === 'RECEIVE' && row.migration ? 'bg-reduce-cap'
                              : row.paySide === 'RECEIVE' && !row.migration ? 'bg-receive'
                                : row.paySide === 'NONE' && row.migration ? 'bg-nonemi' : 'bg-none'">
                          <td class="text-sm font-weight-normal">
                            <material-checkbox v-model="row.chk" :checked="row.chk" :disabled="(selectGroup && row.paymentGroupUid !== groupuid && groupuid !== '')
                              || (selectType && row.type !== typeTrans && typeTrans !== '')"
                              @change="onSelectListQ02(row)">
                            </material-checkbox>
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ formatNumberString(index + 1) }}</td>
                          <td class="text-sm font-weight-normal">{{ row.jobId }}</td>
                          <td class="text-sm font-weight-normal">{{ row.trayId }}</td>
                          <td class="text-sm font-weight-normal">{{ row.start }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.changeName">
                              {{ row.customerName }}
                            </span>
                            <span v-else>
                              {{ row.tkCustomerName }}
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.changeName">
                              {{ row.tkCustomerName }}
                            </span>
                          </td>

                          <td class="text-sm font-weight-normal">
                            {{ row.prevRefNumber }}
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.payside }}</td>
                          <td class="text-sm font-weight-normal">{{ row.trans }}</td>
                          <td class="text-sm font-weight-normal">{{ row.weight_s }}</td>
                          <td class="text-sm font-weight-normal">{{ row.quantity_s }}</td>
                          <td class="text-sm font-weight-normal">{{ row.newPawnValue_s }}</td>
                          <td class="text-sm font-weight-normal">{{ row.fullValue_s }}</td>
                          <td class="text-sm font-weight-normal">{{ row.interest_s }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.migration">
                              <span
                                v-if="row.migrationType === 'PAWN' || row.migrationType === 'INC_PRINCIPLE' && row.totalPay > 0">
                                <span v-if="row.migrationType === 'INC_PRINCIPLE'">
                                  <span v-if="row.totalPay === row.roundInterest" style="color:blue">
                                    {{ formatNumberDecimalString(row.totalPay) }}
                                  </span>
                                  <span v-else style="color:red">
                                    {{ formatNumberDecimalString(row.totalPay) }}
                                  </span>
                                </span>
                                <span v-else style="color:red">
                                  {{ formatNumberDecimalString(row.totalPay) }}
                                </span>
                              </span>
                              <span
                                v-else-if="row.migrationType === 'PAWN' || row.migrationType === 'INC_PRINCIPLE' && row.totalReceive > 0">
                                <span v-if="row.migrationType === 'INC_PRINCIPLE'">
                                  <span v-if="row.totalReceive === row.roundInterest" style="color:blue">
                                    {{ formatNumberDecimalString(row.totalReceive) }}
                                  </span>
                                  <span v-else style="color:green">
                                    {{ formatNumberDecimalString(row.totalReceive) }}
                                  </span>
                                </span>
                                <span v-else style="color:green">
                                  {{ formatNumberDecimalString(row.totalReceive) }}
                                </span>
                              </span>
                              <span v-else-if="row.migrationType === 'INTEREST' && row.totalPay > 0">
                                <span v-if="row.totalPay !== row.roundInterest" style="color:blue">
                                  {{ formatNumberDecimalString(row.totalPay) }}
                                </span>
                                <span v-else style="color:red">
                                  {{ formatNumberDecimalString(row.totalPay) }}
                                </span>
                              </span>
                              <span v-else-if="row.migrationType === 'INTEREST' && row.totalReceive > 0">
                                <span v-if="row.totalReceive !== row.roundInterest" style="color:blue">
                                  {{ formatNumberDecimalString(row.totalReceive) }}
                                </span>
                                <span v-else style="color:green">
                                  {{ formatNumberDecimalString(row.totalReceive) }}
                                </span>
                              </span>
                              <span v-else>
                                <span v-if="row.totalPay > 0" style="color:red">
                                  {{ formatNumberDecimalString(row.totalPay) }}
                                </span>
                                <span v-else-if="row.totalReceive > 0" style="color:green">
                                  {{ formatNumberDecimalString(row.totalReceive) }}
                                </span>
                                <span v-else>
                                  {{ formatNumberDecimalString(row.totalReceive) }}
                                </span>
                              </span>
                            </span>
                            <span v-else>
                              <span
                                v-if="row.type === 'DEC_PRINCIPLE' || row.type === 'INC_PRINCIPLE' || row.type === 'REDEEM'">
                                <span v-if="row.totalPay !== 0">
                                  <span v-if="row.totalPay === row.roundInterest" style="color:blue">
                                    {{ formatNumberDecimalString(row.totalPay) }}
                                  </span>
                                  <span v-else style="color:red">
                                    {{ formatNumberDecimalString(row.totalPay) }}
                                  </span>
                                </span>
                                <span v-else-if="row.totalReceive !== 0">
                                  <span v-if="row.totalReceive === row.roundInterest" style="color:blue">
                                    {{ formatNumberDecimalString(row.totalReceive) }}
                                  </span>
                                  <span v-else style="color:green">
                                    {{ formatNumberDecimalString(row.totalReceive) }}
                                  </span>
                                </span>
                                <span v-else>
                                  {{ formatNumberDecimalString(row.payOrReceive) }}
                                </span>
                              </span>
                              <span v-else-if="row.type === 'INTEREST'">
                                <span v-if="row.totalPay !== 0">
                                  <span v-if="row.totalPay !== row.roundInterest" style="color:blue">
                                    {{ formatNumberDecimalString(row.totalPay) }}
                                  </span>
                                  <span v-else style="color:red">
                                    {{ formatNumberDecimalString(row.totalPay) }}
                                  </span>
                                </span>
                                <span v-else-if="row.totalReceive !== 0">
                                  <span v-if="row.totalReceive !== row.roundInterest" style="color:blue">
                                    {{ formatNumberDecimalString(row.totalReceive) }}
                                  </span>
                                  <span v-else style="color:green">
                                    {{ formatNumberDecimalString(row.totalReceive) }}
                                  </span>
                                </span>
                                <span v-else>
                                  {{ formatNumberDecimalString(row.totalReceive) }}
                                </span>
                              </span>
                              <span v-else>
                                <span v-if="row.totalPay !== 0" style="color:red">
                                  {{ formatNumberDecimalString(row.totalPay) }}
                                </span>
                                <span v-else-if="row.totalReceive !== 0" style="color:green">
                                  {{ formatNumberDecimalString(row.totalReceive) }}
                                </span>
                                <span v-else>
                                  {{ formatNumberDecimalString(row.totalReceive) }}
                                </span>
                              </span>
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.latestUserName }}</td>

                        </tr>
                      </tbody>

                    </table>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-12 d-flex justify-content-end">
                    <div>
                      <material-button id="lockTicket" color="primary" class="float-lg-start float-sm-end mb-3"
                        @click="chkSelect()" :disabled="listQ03.length === 0 || listQ03.filter(item => item.chk === true).length === 0">
                        <i class="material-icons material-symbols-outlined">lock</i>
                        {{ $t("content.amnselectlist") }}
                      </material-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="secondHome" class="tab-pane fade" role="tabpanel" aria-labelledby="second-home-tab">
            <div class="card mt-2">
              <div class="card-header mb-0">
                <h5>{{ $t("content.amnalljobs") }}</h5>
              </div>

              <div class="card-body pt-0">
                <div class="row mt-2">
                  <div class="col-12 d-flex">
                    <div class="me-3">
                      <material-button color="success" class="float-lg-start float-sm-end mb-3" @click="onOpenQRModal">
                        <i class="material-icons material-symbols-outlined">qr_code_scanners</i>
                        {{ $t("buttons.sscan") }}
                      </material-button>
                      <material-button color="success" class="float-lg-start float-sm-end mb-3" data-bs-toggle="modal"
                        data-bs-target="#qrcodeModal" id="qrModalShow" v-show="false">
                      </material-button>
                    </div>
                    <div class="col-8 me-3">
                      <material-input type="text" v-model="qr_serach2" :placeholder="t(`content.amnjobcode`)"
                        @keyup.enter="setResultQRTab2" />
                    </div>
                  </div>
                </div>
                <hr />
                <div class="row">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>

                          <th>#</th>
                          <th>{{ $t("content.jobId") }}</th>
                          <th>{{ $t("content.trayId") }}</th>
                          <th>{{ $t("content.amndatetime") }}</th>
                          <th>{{ $t("content.tkOwner") }}</th>
                          <th>{{ $t("content.oldname") }}</th>
                          <th>{{ $t("content.refnumberold") }}</th>
                          <th>{{ $t("content.refnumbernew") }}</th>
                          <th>{{ $t("content.payside") }}</th>
                          <th>{{ $t("content.amnbiz") }}</th>
                          <th>{{ $t("content.amnweightvalall") }}</th>
                          <th>{{ $t("content.amnqtyunitall") }}</th>
                          <th>{{ $t("content.amnanalysval") }}</th>
                          <th>{{ $t("content.amnmaxvalall") }}</th>
                          <th>{{ $t("content.amnreceiveprofit") }}</th>
                          <th>{{ $t("content.gpay") }}</th>
                          <th>{{ $t("content.amnlastmaker") }}</th>
                          <th>{{ $t("content.act") }}</th>
                        </tr>
                      </thead>

                      <tbody data-group-index="0">

                        <tr v-for="(row, index) in listQ03O" :key="index" :class="row.paySide == 'PAY' && row.migration ? 'bg-redeem'
                          : row.paySide == 'PAY' && !row.migration ? 'bg-payment'
                            : row.paySide === 'RECEIVE' && row.migration ? 'bg-reduce-cap'
                              : row.paySide === 'RECEIVE' && !row.migration ? 'bg-receive'
                                : row.paySide === 'NONE' && row.migration ? 'bg-nonemi' : 'bg-none'">

                          <td class="text-sm font-weight-normal">
                            {{ formatNumberString(index + 1) }}</td>
                          <td class="text-sm font-weight-normal">{{ row.jobId }}</td>
                          <td class="text-sm font-weight-normal">{{ row.trayId }}</td>
                          <td class="text-sm font-weight-normal">{{ row.start }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.changeName">
                              {{ row.customerName }}
                            </span>
                            <span v-else>
                              {{ row.tkCustomerName }}
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.changeName">
                              {{ row.tkCustomerName }}
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ row.prevRefNumber }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ row.refNumber }}
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.payside }}</td>
                          <td class="text-sm font-weight-normal">{{ row.trans }}</td>
                          <td class="text-sm font-weight-normal">{{ row.weight_s }}</td>
                          <td class="text-sm font-weight-normal">{{ row.quantity_s }}</td>
                          <td class="text-sm font-weight-normal">{{ row.newPawnValue_s }}</td>
                          <td class="text-sm font-weight-normal">{{ row.fullValue_s }}</td>
                          <td class="text-sm font-weight-normal">{{ row.interest_s }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="row.migration">
                              <span
                                v-if="row.migrationType === 'PAWN' || row.migrationType === 'INC_PRINCIPLE' && row.totalPay > 0">
                                <span v-if="row.migrationType === 'INC_PRINCIPLE'">
                                  <span v-if="row.totalPay === row.roundInterest" style="color:blue">
                                    {{ formatNumberDecimalString(row.totalPay) }}
                                  </span>
                                  <span v-else style="color:red">
                                    {{ formatNumberDecimalString(row.totalPay) }}
                                  </span>
                                </span>
                                <span v-else style="color:red">
                                  {{ formatNumberDecimalString(row.totalPay) }}
                                </span>
                              </span>
                              <span
                                v-else-if="row.migrationType === 'PAWN' || row.migrationType === 'INC_PRINCIPLE' && row.totalReceive > 0">
                                <span v-if="row.migrationType === 'INC_PRINCIPLE'">
                                  <span v-if="row.totalReceive === row.roundInterest" style="color:blue">
                                    {{ formatNumberDecimalString(row.totalReceive) }}
                                  </span>
                                  <span v-else style="color:green">
                                    {{ formatNumberDecimalString(row.totalReceive) }}
                                  </span>
                                </span>
                                <span v-else style="color:green">
                                  {{ formatNumberDecimalString(row.totalReceive) }}
                                </span>
                              </span>
                              <span v-else-if="row.migrationType === 'INTEREST' && row.totalPay > 0">
                                <span v-if="row.totalPay !== row.roundInterest" style="color:blue">
                                  {{ formatNumberDecimalString(row.totalPay) }}
                                </span>
                                <span v-else style="color:red">
                                  {{ formatNumberDecimalString(row.totalPay) }}
                                </span>
                              </span>
                              <span v-else-if="row.migrationType === 'INTEREST' && row.totalReceive > 0">
                                <span v-if="row.totalReceive !== row.roundInterest" style="color:blue">
                                  {{ formatNumberDecimalString(row.totalReceive) }}
                                </span>
                                <span v-else style="color:green">
                                  {{ formatNumberDecimalString(row.totalReceive) }}
                                </span>
                              </span>
                              <span v-else>
                                <span v-if="row.totalPay > 0" style="color:red">
                                  {{ formatNumberDecimalString(row.totalPay) }}
                                </span>
                                <span v-else-if="row.totalReceive > 0" style="color:green">
                                  {{ formatNumberDecimalString(row.totalReceive) }}
                                </span>
                                <span v-else>
                                  {{ formatNumberDecimalString(row.totalReceive) }}
                                </span>
                              </span>
                            </span>
                            <span v-else>
                              <span
                                v-if="row.type === 'DEC_PRINCIPLE' || row.type === 'INC_PRINCIPLE' || row.type === 'REDEEM'">
                                <span v-if="row.totalPay !== 0">
                                  <span v-if="row.totalPay === row.roundInterest" style="color:blue">
                                    {{ formatNumberDecimalString(row.totalPay) }}
                                  </span>
                                  <span v-else style="color:red">
                                    {{ formatNumberDecimalString(row.totalPay) }}
                                  </span>
                                </span>
                                <span v-else-if="row.totalReceive !== 0">
                                  <span v-if="row.totalReceive === row.roundInterest" style="color:blue">
                                    {{ formatNumberDecimalString(row.totalReceive) }}
                                  </span>
                                  <span v-else style="color:green">
                                    {{ formatNumberDecimalString(row.totalReceive) }}
                                  </span>
                                </span>
                                <span v-else>
                                  {{ formatNumberDecimalString(row.payOrReceive) }}
                                </span>
                              </span>
                              <span v-else-if="row.type === 'INTEREST'">
                                <span v-if="row.totalPay !== 0">
                                  <span v-if="row.totalPay !== row.roundInterest" style="color:blue">
                                    {{ formatNumberDecimalString(row.totalPay) }}
                                  </span>
                                  <span v-else style="color:red">
                                    {{ formatNumberDecimalString(row.totalPay) }}
                                  </span>
                                </span>
                                <span v-else-if="row.totalReceive !== 0">
                                  <span v-if="row.totalReceive !== row.roundInterest" style="color:blue">
                                    {{ formatNumberDecimalString(row.totalReceive) }}
                                  </span>
                                  <span v-else style="color:green">
                                    {{ formatNumberDecimalString(row.totalReceive) }}
                                  </span>
                                </span>
                                <span v-else>
                                  {{ formatNumberDecimalString(row.totalReceive) }}
                                </span>
                              </span>
                              <span v-else>
                                <span v-if="row.totalPay !== 0" style="color:red">
                                  {{ formatNumberDecimalString(row.totalPay) }}
                                </span>
                                <span v-else-if="row.totalReceive !== 0" style="color:green">
                                  {{ formatNumberDecimalString(row.totalReceive) }}
                                </span>
                                <span v-else>
                                  {{ formatNumberDecimalString(row.totalReceive) }}
                                </span>
                              </span>
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ row.latestUserName }}</td>
                          <td class="text-sm font-weight-normal">
                            <material-button color="info" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="top" :title="t('content.amnticketmanage')"
                              @click="openTab(row)" :disabled="canEdit(row)">
                              <i class="material-icons material-symbols-outlined">edit</i>
                            </material-button>
                            <material-button color="warning" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="top" :title="t('content.amnunlock')"
                              @click="onUnLockDialog(row)"
                              :disabled="(row.step.code !== 'S030' && row.step.code !== 'S050') || (row.step.code === 'S030' && row.step.name === 'Re-Pack')">
                              <i class="material-icons material-symbols-outlined">lock_open</i>
                            </material-button>
                            <material-button color="primary" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="top" :title="t('content.amncollec')"
                              @click="onKeepDialog(row)" :disabled="canKeep(row)">
                              <i class="material-icons material-symbols-outlined">shopping_cart</i>
                            </material-button>
                            <material-button color="info" variant="outline" class="rounded-circle"
                              :title="t('buttons.seed')" @click="openDetail(row)">
                              <i class="material-icons material-symbols-outlined">visibility</i>
                            </material-button>
                            <material-button color="danger" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="top" :title="t('content.errorticket')"
                              @click="onCancelTicketDialog(row)" :disabled="canCancel(row)">
                              <i class="material-icons material-symbols-outlined">close</i>
                            </material-button>
                            <material-button color="dark" variant="outline" class="rounded-circle"
                              data-bs-toggle="tooltip" data-bs-placement="top" :title="t('buttons.printp')"
                              @click="ticketGen(row)" :disabled="canPrint(row)">
                              <i class="material-icons material-symbols-outlined">print</i>
                            </material-button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="thirdHome" class="tab-pane fade" role="tabpanel" aria-labelledby="third-home-tab">
            <div class="card mt-4">
              <div class="card-header">
                <h5>{{ $t("content.persontinfo") }} ({{ $t("content.tkOwner") }} :
                  <span v-if="listQ03E.changeName">
                    {{ listQ03E.customerName }}
                  </span>
                  <span v-else>
                    {{ listQ03E.tkCustomerName }}
                  </span>)

                </h5>
              </div>

              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-lg-6">
                    <label class="form-label ms-0">{{ $t('content.cnam') }} - {{ $t('content.clsnam')
                      + " (" + $t("content.th") + ")" }}
                      <span class="text-primary">
                        <b>*{{ $t('content.tkcusname') }}</b>
                      </span>
                    </label>
                    <material-input v-model="cus_detail.nameTh" type="text" disabled />
                  </div>

                  <div class="col-lg-6">
                    <label class="form-label ms-0">{{ $t('content.cnam') }} - {{ $t('content.clsnam')
                      + " (" + $t("content.en") + ")" }}</label>
                    <material-input v-model="cus_detail.nameEn" type="text" disabled />
                  </div>
                  <div class="col-lg-4">
                    <label class="form-label ms-0">{{ $t("content.cmobile") }}1*</label>
                    <span v-if="cus_detail.cusShop !== null">
                      <InputMask v-model="cus_detail.cusShop.phoneNo1" mask="(999) 999-9999" fluid disabled />
                    </span>
                    <span v-else>
                      <material-input type="text" disabled />
                    </span>
                  </div>
                  <div class="col-lg-4">
                    <label class="form-label ms-0">{{ $t("content.cmobile") }}2</label>
                    <span v-if="cus_detail.cusShop !== null">
                      <InputMask v-model="cus_detail.cusShop.phoneNo2" mask="(999) 999-9999" fluid disabled />
                    </span>
                    <span v-else>
                      <material-input type="text" disabled />
                    </span>
                  </div>
                  <div class="col-lg-4">
                    <label class="form-label ms-0">{{ $t("content.cmobile") }}3</label>
                    <span v-if="cus_detail.cusShop !== null">
                      <InputMask v-model="cus_detail.cusShop.phoneNo3" mask="(999) 999-9999" fluid disabled />
                    </span>
                    <span v-else>
                      <material-input type="text" disabled />
                    </span>
                  </div>
                </div>
              </div>

              <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                  <h6 class="mb-0 me-4">
                    <b>{{ $t('content.amnassetowner') }}/{{ $t('content.cabove') }}
                      <span v-if="listQ03E.prevRefNumber !== '' && listQ03E.prevRefNumber !== null">
                          <span v-if="workcaseDetail_prv !== null && workcaseDetail_prv.deposit">
                            ({{ $t("content.refnumber") }} : {{ listQ03E.prevRefNumber }} ,
                            <span style="color:blue;">
                              {{ $t('content.gkeepno') }} : {{dep_no}}
                            </span>)
                          </span>
                          <span v-else>
                            ({{ $t("content.refnumber") }} : {{ listQ03E.prevRefNumber }})
                          </span>
                        </span>
                    </b>
                  </h6>

                  <div class="col">
                    <div class="input-group">
                      <input v-model="cusName_search" type="text" class="form-control"
                        style="margin-bottom: 0 !important" aria-describedby="searchNameOwner" :placeholder="$t('buttons.sear') +
                          ' ' +
                          $t('content.amnassetowner') +
                          '/' +
                          $t('content.cabove')
                          " readonly />
                      <button id="searchNameOwner" class="btn btn-primary mb-0" type="button" data-bs-toggle="modal"
                        data-bs-target="#relationPersonalModal" disabled>
                        <i class="material-icons material-symbols-outlined">search</i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <div class="mb-3 pt-2" v-if="workcaseDetail !== null">
                  <div class="d-flex justify-content-between align-items-center">
                    <h6 class="mb-0 me-4">
                      <span v-if="workcaseDetail.migration" style="color:red;">
                        <b>{{ $t("content.migraref") }}</b>
                      </span>
                      <span v-else>
                        <b>{{ $t("content.migraref") }}</b>
                      </span>
                    </h6>
                    <div class="col">
                      <div class="input-group">
                        <material-input v-model="workcaseDetail.migrateRefNumber" class="hl-label" disabled="true" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row review mb-3 pt-2">
                  <div class="col-lg-2">
                    <label class="form-label hl-label ms-0">{{
                      $t("content.amnhdweightalltick")
                    }}</label>
                    <material-input v-model="listQ03E.weight_s" class="hl-label" disabled="true" />
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label hl-label ms-0">{{
                      $t("content.amnhdanalysalltick")
                    }}</label>
                    <material-input v-model="listQ03E.newPawnValue_s" class="hl-label" disabled="true" />
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label hl-label ms-0">{{
                      $t("content.amnhdmaxalltick")
                    }}</label>
                    <material-input v-model="listQ03E.fullValue_s" class="hl-label" disabled="true" />
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label hl-label ms-0">{{ $t("content.cintrate") }}</label>
                    <material-input v-model="interestRate_s" class="hl-label" disabled="true" />
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label hl-label ms-0">{{ $t("content.ttprointerest") }}</label>
                    <material-input v-model="promoint_val" class="hl-label" disabled="true" />
                  </div>

                   <div class="col-lg-2">
                    <label class="form-label hl-label ms-0">{{
                      $t("content.periodpromotion")
                    }}</label>
                    <material-input v-model="promoint_duration" class="hl-label" disabled="true" />
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label hl-label ms-0">{{
                      $t("content.amnhdweightrest")
                    }}</label>
                    <material-input v-model="balweight_s" class="hl-label" disabled="true" />
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label hl-label ms-0">{{
                      $t("content.amnhdanalysrest")
                    }}</label>
                    <material-input v-model="balprice_s" class="hl-label" disabled="true" />
                  </div>

                  <div class="col-lg-2">
                    <label class="form-label hl-label ms-0">{{
                      $t("content.amnhdmaxrest")
                    }}</label>
                    <material-input v-model="balfull_s" class="hl-label" disabled="true" />
                  </div>

                  <div class="col-lg-2">
                      <label class="form-label hl-label ms-0">{{
                        $t("content.amnreceiveprofit")
                      }}</label>
                      <span v-if="workcaseDetail !== null">
                        <material-input v-model="formattedInterest" class="hl-label" disabled="true" />
                      </span>
                      <span v-else>
                        <material-input value="0.00" class="hl-label" disabled="true" />
                      </span>
                    </div>

                    <div class="col-lg-2">
                      <label class="form-label hl-label ms-0">{{
                        $t("content.spedis")
                      }}</label>
                      <span v-if="workcaseDetail !== null && workcaseDetail.interestRef !== null">
                         <material-input v-model="formattedDiscount" class="hl-label" disabled="true" />
                      </span>
                      <span v-else>
                        <material-input value="0.00" class="hl-label" disabled="true" />
                      </span>
                    </div>


                  <div class="col-lg-2">
                    <label class="form-label hl-label ms-0">{{
                      $t("content.ttintrec")
                    }}</label>
                    <material-input v-model="listQ03E.interest_s" class="hl-label" disabled="true" />
                  </div>

                 
                </div>

                <div class="row mt-4 no-gutters">
                  <div class="col-8 d-flex justify-content-end align-items-center">
                    <div class="left">
                      <div class="me-1">
                        <h6>
                          <b>{{ $t("content.amnassetdatasinfo") }}</b>
                        </h6>
                      </div>&nbsp;
                      <div class="me-4">
                        <h6 style="color:red" v-if="uid_edit !== '' && workcaseDetail !== null">
                          <b>( {{ listQ03E.trans }}
                            <span v-if="listQ03E.type === 'PAWN' || listQ03E.type === 'REDEEM'">
                              {{ formatNumberDecimalString(workcaseDetail.pawnValue) }}
                            </span>
                            <span v-if="listQ03E.type === 'INTEREST'">
                              {{ formatNumberDecimalString(workcaseDetail.interest) }}
                            </span>
                            <span v-if="listQ03E.type === 'INC_PRINCIPLE' || listQ03E.type === 'DEC_PRINCIPLE'">
                              {{ formatNumberDecimalString(workcaseDetail.diffValue) }}
                            </span>
                            <i i class="inline-icon material-icons">keyboard_double_arrow_right</i>
                            {{ $t("content.gtotal") }}&nbsp;
                            <span style="color:green">
                              {{ $t("content.ttreceive") }}
                            </span>/{{ $t("content.ttpay") }} : </b>
                          <span v-if="listQ03E.migration">
                            <span @click="openDetailPayment()" style="text-decoration:underline; cursor: pointer" title="รายการชำระ"
                              v-if="listQ03E.migrationType === 'PAWN' || listQ03E.migrationType === 'INC_PRINCIPLE' && listQ03E.totalPay > 0">
                              <b>{{ formatNumberDecimalString(listQ03E.totalPay) }}</b>
                            </span>
                            <span @click="openDetailPayment()" style="color:green;text-decoration:underline; cursor: pointer" title="รายการชำระ" v-else>
                              <b>{{ formatNumberDecimalString(listQ03E.totalReceive) }}</b>
                            </span>
                          </span>
                          <span v-else>
                            <span @click="openDetailPayment()" style="text-decoration:underline; cursor: pointer" title="รายการชำระ"
                              v-if="listQ03E.type === 'PAWN' || listQ03E.type === 'INC_PRINCIPLE' && listQ03E.totalPay > 0">
                              <b>{{ formatNumberDecimalString(listQ03E.totalPay) }}</b>
                            </span>
                            <span @click="openDetailPayment()" style="color:green;text-decoration:underline; cursor: pointer" title="รายการชำระ" v-else>
                              <b>{{ formatNumberDecimalString(listQ03E.totalReceive) }}</b>
                            </span>
                          </span>
                          <b> )</b>
                          <span style="color:blue;"
                            v-if="listQ03E.prevRefNumber !== '' && listQ03E.prevRefNumber !== null">
                            &nbsp;
                            {{ $t("content.periodpawn") }} : {{ int_period }} เดือน
                          </span>
                        </h6>
                      </div>
                    </div>
                  </div>


                  <div class="col-4 d-flex justify-content-end align-items-center">
                    <div class="me-3">
                      <material-button color="info" variant="outline" class="float-lg-start float-sm-end mb-3"
                        @click="openDetailPrv()" :title="t('content.oldtkdetail')"
                        :disabled="uid_edit === '' || listQ03E.prevRefNumber === '' || listQ03E.prevRefNumber === null">
                        <i class="material-icons material-symbols-outlined">visibility</i>
                        {{ $t("content.oldtkdetail") }}
                      </material-button>
                      <material-button color="info" variant="outline" class="rounded-circle" v-show="false"
                          data-bs-toggle="modal" data-bs-target="#paymentModal" id="paymentModal2">
                      </material-button>
                    </div>

                    <div class="me-3">
                      <material-button color="primary" class="float-lg-start float-sm-end mb-3"
                        :disabled="images_l.length === 0" @click="openGallery">
                        <i class="material-icons material-symbols-outlined">photo_library</i>
                        {{ $t("content.viewimg") }}
                      </material-button>
                      <material-button color="warning" class="float-lg-start float-sm-end mb-3" data-bs-toggle="modal"
                        data-bs-target="#lookupModal" id="myModalGallery" v-show="false">
                        <i class="material-icons material-symbols-outlined">photo_library</i>
                        {{ $t("content.viewimg") }}
                      </material-button>
                    </div>
                  </div>
                </div>

                <div class="row mt-4">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>

                          <th>#</th>
                          <th>{{ $t("content.amndatetime") }}</th>
                          <th>{{ $t("content.amnbiz") }}</th>
                          <th>{{ $t("content.amnassetgroup") }}</th>
                          <th>{{ $t("content.amnweightval") }}</th>
                          <th>{{ $t("content.amnqtyunit") }}</th>
                          <th>{{ $t("content.amnanalysval") }}</th>
                          <th>{{ $t("content.amnmaxval") }}</th>

                        </tr>
                      </thead>
                      <tbody>
                        <!-- <tr style="background-color: transparent;"> -->
                        <tr v-for="(row, index) in listinfo_coll" :key="index">

                          <td class="text-sm font-weight-normal">{{ formatNumberString(index + 1) }}</td>
                          <td class="text-sm font-weight-normal">
                            {{ listQ03E.start }}
                          </td>
                          <td class="text-sm font-weight-normal">
                            {{ listQ03E.trans }} </td>
                          <td class="text-sm font-weight-normal">{{ filterCat(row.mainCatUid) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.weight) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberString(row.quantity) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.pawnValue)
                          }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.fullValue)
                          }}</td>

                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <hr />

                <div class="row mt-4 no-gutters">
                  <div class="col-12 d-flex justify-content-end align-items-center">
                    <div class="left">
                      <div class="me-2">
                        <h6>
                          <b>{{ $t("content.amnassetdatas") }}</b>
                        </h6>
                      </div>&nbsp;
                      <div class="me-2" v-if="uid_edit !== '' && workcaseDetail !== null">
                        <h6 style="color:red" v-if="workcaseDetail.represent || workcaseDetail.shopRepresent">
                          ({{ $t("content.represent") }}
                          <i class="inline-icon material-icons">keyboard_double_arrow_right</i>
                         {{ workcaseDetail.customerInfo.name }})
                        </h6>
                        <h6 style="color:red" v-if="workcaseDetail.changeName">
                          ({{ $t("content.changeName") }} ({{ workcaseDetail.tkCustomerInfo.name }})
                          <i class="inline-icon material-icons">keyboard_double_arrow_right</i>
                          {{ listQ03E.customerName }})
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row mt-4">
                  <div class="table-responsive">
                    <table class="table table-flush">
                      <thead class="thead-light">
                        <tr>

                          <th>#</th>
                          <th>{{ $t("content.amndatetime") }}</th>
                          <th>{{ $t("content.amnbiz") }}</th>
                          <th>{{ $t("content.amnassetgroup") }}</th>
                          <th>{{ $t("content.amnweightval") }}</th>
                          <th>{{ $t("content.amnqtyunit") }}</th>
                          <th>{{ $t("content.amnanalysval") }}</th>
                          <th>{{ $t("content.amnmaxval") }}</th>

                        </tr>
                      </thead>
                      <tbody v-for="(row, index) in listQ03D" :key="index">
                        <tr class="group-id-ticket" :class="row.st == 'finished' ? '' : 'bg-working'">
                          <td class="text-sm font-weight-normal">
                            <div class="group-tickect" style="padding: 0.5rem !important">
                              {{ formatNumberString(index + 1) }}
                            </div>
                          </td>
                          <td class="text-sm font-weight-normal">{{ listQ03E.start }}</td>
                          <td class="text-sm font-weight-normal">{{ listQ03E.trans }}</td>
                          <td class="text-sm font-weight-normal">{{ filterCat(row.mainCatUid) }}</td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.weight) }}
                          </td>
                          <td class="text-sm font-weight-normal">{{ formatNumberString(row.quantity) }}</td>
                          <td class="text-sm font-weight-normal">
                            <span v-if="listQ03E.type !== 'INC_PRINCIPLE' && listQ03E.type !== 'DEC_PRINCIPLE'">
                              {{ formatNumberDecimalString(row.newPawnValue) }}
                            </span>
                            <span v-else>
                              {{ formatNumberDecimalString(row.tmpNewPawnValue) }}
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal">{{ formatNumberDecimalString(row.fullValue)
                          }}</td>

                        </tr>
                        <tr v-for="(j, set1) in row.remarkL" :key="set1">
                          <td class="text-sm font-weight-normal text-end" colspan="2">
                            <span style="text-decoration:underline">
                              {{ $t("content.amnassetdetail") }}
                            </span>
                          </td>
                          <td class="text-sm font-weight-normal" colspan="6">
                            <span style="color:red">
                              <b>{{ j.val }}</b>
                            </span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="row mt-2">
                  <div class="col-3 d-flex justify-content-between align-items-center">
                    <material-button color="default" class="float-lg-start float-sm-end mb-3" @click="backToSecondTab">
                      <i class="material-icons material-symbols-outlined">close</i>
                      {{ cancel }}
                    </material-button>

                  </div>

                  <div class="col-9 d-flex justify-content-end align-items-center">

                    <div class="me-3">
                      <material-button color="danger" class="float-lg-start float-sm-end mb-3"
                        :disabled="uid_edit === ''" @click="onCancelDialog">
                        <i class="material-icons material-symbols-outlined">warning</i>
                        {{ $t("buttons.cancshm") }}
                      </material-button>
                    </div>
                    <div class="me-3">
                      <material-button id="capImage" color="primary" class="float-lg-start float-sm-end mb-3"
                        :disabled="uid_edit === ''" @click="onImgDialog">
                        <i class="material-icons material-symbols-outlined">add_a_photo</i>
                        {{ $t("content.tupload") }}
                      </material-button>
                      <material-button color="primary" variant="outline" class="rounded-circle" data-bs-toggle="modal"
                        data-bs-target="#attachmentsModal" v-show="false" id="attachmenDialog">
                      </material-button>
                    </div>
                    <div class="me-3">
                      <material-button color="warning" class="float-lg-start float-sm-end mb-3"
                        :disabled="uid_edit === ''" @click="onReturnDialog">
                        <i class="material-icons material-symbols-outlined">reply</i>
                        {{ $t("buttons.canccle") }}
                      </material-button>
                    </div>

                    <div class="me-3" v-if="workcaseDetail !== null">
                      <material-button color="info" class="float-lg-start float-sm-end mb-3"
                        :disabled="uid_edit === '' || (workcaseDetail.deposit === false && listQ03E.type === 'REDEEM')"
                        @click="onCompleteDWDialog">
                        <span v-if="workcaseDetail.deposit">
                          {{ $t("content.mwittk") }}
                        </span>
                        <span v-else>
                          {{ $t("content.mdeptk") }}
                        </span>
                        <i class="material-icons material-symbols-outlined">download_done</i>
                      </material-button>
                    </div>

                    <div class="me-3">
                      <material-button color="primary" class="float-lg-start float-sm-end mb-3"
                        :disabled="uid_edit === ''" @click="onCompleteDialog">
                        {{ approve }}
                        <i class="material-icons material-symbols-outlined">forward</i>
                      </material-button>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- Gallery Modal -->
        <div id="lookupModal" class="modal fade" tabindex="-1" aria-labelledby="lookupModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" style="max-width: 520px">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ $t("content.detail") }}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"
                  @click="visible_g = false">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>

              <div class="modal-body">
                <div id="lookupImages" class="carousel slide" data-bs-touch="false" data-bs-interval="false">
                  <div class="carousel-indicators" id="demo1">
                  </div>
                  <div class="carousel-inner">
                    <ul className="list-unstyled">
                      <li v-for="(item, index) in images.length" :key="index">
                        <span v-if="index === 0">
                          <div class="carousel-item active">
                            <vue-image-zoomer :regular="images[index].src" img-class="img-fluid" class="d-block w-100"
                              :zoom-amount="3" :click-zoom="true" close-pos="top-right" message-pos="top" />
                          </div>
                        </span>
                        <span v-else>
                          <div class="carousel-item">
                            <vue-image-zoomer :regular="images[index].src" img-class="img-fluid" class="d-block w-100"
                              :zoom-amount="3" :click-zoom="true" close-pos="top-right" message-pos="top" />
                          </div>
                        </span>
                      </li>
                    </ul>
                  </div>
                  <button class="carousel-control-prev" type="button" data-bs-target="#lookupImages"
                    data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                  </button>
                  <button class="carousel-control-next" type="button" data-bs-target="#lookupImages"
                    data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- QR Code Modal -->
        <div id="qrcodeModal" class="modal fade" tabindex="-1" aria-labelledby="viewQRcodeModalLabel"
          data-bs-keyboard="false" data-bs-backdrop="static" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg " style="max-width: 600px">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ $t("content.qrscan") }}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close" id="closeqr"
                  @click="paused = true">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>
              <div class="modal-body">

                <div class="row">
                  <div class="col-lg-12">
                    <p class="decode-result">
                      {{ $t("content.orderresult") }} : <b>{{ result }}</b>
                    </p>
                    <p class="error">{{ error }}</p>
                  </div>

                  <div class="col-lg-12">

                    <qrcode-stream :paused="paused" @detect="onDetect" @error="onError"
                      @camera-on="resetValidationState" :constraints="selectedConstraints"
                      :track="trackFunctionSelected.value">
                    </qrcode-stream>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>


        <NewCamera v-if="hideCam" v-model="hideCam" @close="closeCamera" @save="savephotoTaken" />


        <!-- Add File Dialog -->
        <div id="attachmentsModal" class="modal fade" tabindex="-1" aria-labelledby="unseizeModalLabel"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg" style="max-width: 800px">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  {{ cus_detail.nameTh }}
                  ({{ $t("content.ticketno") }} : <span
                    v-if="listQ03E.prevRefNumber !== '' && listQ03E.prevRefNumber !== null">
                    {{ listQ03E.prevRefNumber }}
                  </span><span v-else>-</span>)
                </h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>
              <div class="modal-body">
                <div class="container-fluid">
                  <div class="row">
                    <fieldset>
                      <div class="row">
                        <div class="col-lg-12">
                          {{ $t("content.previmg") }} : {{ images.length }}
                        </div>
                      </div>
                      <pre></pre>
                      <div class="grid-containerP" v-if="images.length">
                        <div v-for="item, index in images" :key="index" class="d-inline-block mx-2">
                          <td>
                            <div class="wrapperP">
                              <figure width="100px" height="100px">
                                <img :src="item.src" class="img img-fluid" />
                              </figure>
                            </div>
                          </td>
                        </div>
                      </div>
                    </fieldset>
                    <hr />
                    <fieldset>
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="d-flex align-items-center mb-1">
                          </div>
                          <input id="upload" type="file" accept="image/*" @change="addFile" />
                        </div>
                      </div>
                      <pre></pre>
                      <div class="row">
                        <div class="col-lg-12">
                          <div class="bank-logo d-flex align-items-center mb-1" v-if="preview !== ''">
                            <img :src="preview" alt="" :width="picWidth" :height="picHeight" aspect-ratio="1" />
                          </div>
                        </div>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>

              <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="thumb = null">
                  {{ cancel }}
                </button>
                <button type="button" class="btn btn-primary" data-bs-dismiss="modal">
                  {{ save }}
                </button>
              </div>
            </div>
          </div>
        </div>


        <TicketDetailModal 
          v-if="activeDetail !== null"
          :workcaseDetail="activeDetail"
          :images="images"
          :listinfo="listinfo"
          :paymentE="paymentE"
          :paymentL="payment_l"
          :promotionDetail="promotionDetail"
          :depRef="dep_ref"
          :tkStatus="tk_status"
          :intCal="int_cal"
          :intPeriod="int_period"
          :transactionLabel="checkTransaction(activeDetail.transactionType)"
          :history="'no'" 
          v-model:fcusdt="fcusdt" 
          :afChangename=af_changename
          :bfChangename=bf_changename
          :transDatePrv=transdate_prv
          @copy="copyBtn"
          @openHistory="NewTab"/> 


        <!-- Payment Detail Modal -->
        <div id="paymentModal" class="modal fade" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-xl modal-dialog-centered" style="max-width:1450px;">
            <div class="modal-content">
              <div class="modal-header">
                <h4 class="modal-title">{{ $t("content.amnfinanceinfo") }}</h4>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                  <i class="material-icons material-symbols-outlined">close</i>
                </button>
              </div>

              <div class="modal-body">
                <div class="col-12 mt-2">
                  <pre></pre>
                  <div class="row">
                    <div class="table-responsive">
                      <table class="table table-flush">
                        <thead class="thead-light">
                          <tr>
                            <th>#</th>
                            <th>{{ $t("content.ticketno") }}</th>
                            <th>{{ $t("content.amnbiz") }}</th>
                            <th colspan="5" class="align-top text-center" style="background-color:#dfffdd;">
                              <span style="color:black;">
                                {{ $t("content.amnincome") }}
                              </span>
                            </th>
                            <th colspan="4" class="align-top text-center" style="background-color:#fecac7;">
                              <span style="color:black;">
                                {{ $t("content.amnoutcome") }}
                              </span>
                            </th>
                            <th colspan="4" class="align-top text-center" style="background-color:#CFEBFD;">
                              <span style="color:black;">
                                {{ $t("content.fee") }}
                              </span>
                            </th>
                          </tr>
                          <tr>
                            <th colspan="3"></th>
                            <th class="align-top text-center" style="background-color:#dfffdd;">
                              <span style="color:black;">
                                {{ $t("content.amncash") }}
                              </span>
                            </th>
                            <th colspan="2" class="align-top text-center" style="background-color:#dfffdd;">
                              <span style="color:black;">
                                {{ $t("content.amnbanktransfer") }}
                              </span>
                            </th>
                            <th class="align-top text-center" style="background-color:#dfffdd;">
                              <span style="color:black;">
                                {{ $t("content.amncreditcard") }}
                              </span>

                            </th>
                            <th class="align-top text-center" style="background-color:#dfffdd;">
                              <span style="color:black;">
                                {{ $t("content.amncheque") }}
                              </span>
                            </th>
                            <th class="align-top text-center" style="background-color:#fecac7;">
                              <span style="color:black;">
                                {{ $t("content.amncash") }}
                              </span>
                            </th>
                            <th colspan="3" class="align-top text-center" style="background-color:#fecac7;">
                              <span style="color:black;">
                                {{ $t("content.amnbanktransfer") }}
                              </span>
                            </th>
                            <th class="align-top text-center" style="background-color:#CFEBFD;">
                              <span style="color:black;">
                                {{ $t("content.amncash") }}
                              </span>
                            </th>
                            <th colspan="2" class="align-top text-center" style="background-color:#CFEBFD;">
                              <span style="color:black;">
                                {{ $t("content.amnbanktransfer") }}
                              </span>
                            </th>
                            <th class="align-top text-center" style="background-color:#CFEBFD;">
                              <span style="color:black;">
                                {{ $t("content.amncreditcard") }}
                              </span>
                            </th>
                          </tr>
                          <tr>
                            <th colspan="3"></th>
                            <th style="background-color:#dfffdd;"></th>
                            <th class="align-top text-center" style="background-color:#dfffdd;">
                              <span style="color:black;">
                                {{ $t("content.amnbankacc") }}
                              </span>
                            </th>
                            <th class="align-top text-center" style="background-color:#dfffdd;">
                              <span style="color:black;">
                                QR Code
                              </span>
                            </th>
                            <th colspan="2" style="background-color:#dfffdd;"></th>
                            <th style="background-color:#fecac7;"></th>
                            <th class="align-top text-center" style="background-color:#fecac7;">
                              <span style="color:black;">
                                {{ $t("content.amnbankacc") }}
                              </span>
                            </th>
                            <th class="align-top text-center" style="background-color:#fecac7;">
                              <span style="color:black;">
                                {{ $t("content.amntransfer_promt_mobile") }}
                              </span>
                            </th>
                            <th class="align-top text-center" style="background-color:#fecac7;">
                              <span style="color:black;">
                                {{ $t("content.amntransfer_promt_taxid") }}
                              </span>
                            </th>
                            <th style="background-color:#CFEBFD;"></th>
                            <th class="align-top text-center" style="background-color:#CFEBFD;">
                              <span style="color:black;">
                                {{ $t("content.amnbankacc") }}
                              </span>
                            </th>
                            <th class="align-top text-center" style="background-color:#CFEBFD;">
                              <span style="color:black;">
                                QR Code
                              </span>
                            </th>
                            <th style="background-color:#CFEBFD;"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, index) in paymentE.workCases" :key="index">
                            <template v-if="row.ticket !== null">
                              <td class="text-sm font-weight-normal text-center">{{ formatNumberString(index + 1) }}
                              </td>
                              <td class="text-sm font-weight-normal text-center">{{ row.tkRefNumber }}</td>
                              <td class="text-sm font-weight-normal text-center">{{
                                checkTransaction(row.transactionType) }}</td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[0].receive > 0" style="color:green;">
                                  {{ formatNumberDecimalString(payment_l[0].receive) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[1].receive > 0" style="color:green;">
                                  {{ formatNumberDecimalString(payment_l[1].receive) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[6].receive > 0" style="color:green;">
                                  {{ formatNumberDecimalString(payment_l[6].receive) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[2].receive > 0" style="color:green;">
                                  {{ formatNumberDecimalString(payment_l[2].receive) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[3].receive > 0" style="color:green;">
                                  {{ formatNumberDecimalString(payment_l[3].receive) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[0].pay > 0" style="color:red;">
                                  {{ formatNumberDecimalString(payment_l[0].pay) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[1].pay > 0" style="color:red;">
                                  {{ formatNumberDecimalString(payment_l[1].pay) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[4].pay > 0" style="color:red;">
                                  {{ formatNumberDecimalString(payment_l[4].pay) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[5].pay > 0" style="color:red;">
                                  {{ formatNumberDecimalString(payment_l[5].pay) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[0].fee > 0" style="color:blue;">
                                  {{ formatNumberDecimalString(payment_l[0].fee) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[1].fee > 0" style="color:blue;">
                                  {{ formatNumberDecimalString(payment_l[1].fee) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[6].fee > 0" style="color:blue;">
                                  {{ formatNumberDecimalString(payment_l[6].fee) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                              <td v-if="index == 0" class="text-sm font-weight-normal text-center"
                                :rowspan="paymentE.workCases.length">
                                <span v-if="payment_l[2].fee > 0" style="color:blue;">
                                  {{ formatNumberDecimalString(payment_l[2].fee) }}
                                </span>
                                <span v-else>
                                  -
                                </span>
                              </td>
                            </template>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>



      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable no-unused-vars */
import ProgressSpinner from 'primevue/progressspinner';
import { QrcodeStream } from 'vue-qrcode-reader'
import InputMask from 'primevue/inputmask';
import { reactive, inject, computed, onMounted, ref , nextTick  } from "vue";
import { useI18n } from "vue-i18n";
import * as Choices from "choices.js";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import MaterialCheckbox from "@/components/MaterialCheckbox.vue";
import NewCamera from "../../examples/WebCam/NewCamera.vue";
import { VueImageZoomer } from 'vue-image-zoomer'
import 'vue-image-zoomer/dist/style.css';
import TicketDetailModal from '@/components/TicketDetailModal.vue';
import Modal from 'bootstrap/js/dist/modal';

import { useWorkItemStore } from '@/stores/workItem'
import { useCategoryStore } from '@/stores/category'
import { useCustomerStore } from '@/stores/customer'
import { useWorkCaseStore } from '@/stores/workcase'
import { useDocumentStore } from '@/stores/document'
import { useTicketImageStore } from '@/stores/ticketimage'
import { usePaymentGroupStore } from '@/stores/paymentgroup'
import { useInterestStore } from '@/stores/interest'
import { useCashAccountStore } from '@/stores/cashaccount'
import { useDepositStore } from '@/stores/deposit'
import { useMigrationTkStore } from '@/stores/migrationtk'


import axios from "axios";
import * as st from "@/config/setting.js";
import moment from 'moment'
import noImg from "@/assets/img/noimg.png"



const storew = useWorkItemStore()
const storec = useCategoryStore()
const storecus = useCustomerStore()
const storewc = useWorkCaseStore()
const stored = useDocumentStore()
const storeti = useTicketImageStore()
const storep = usePaymentGroupStore()
const storei = useInterestStore()
const storeca = useCashAccountStore()
const storedepo = useDepositStore()
const storemigtk = useMigrationTkStore()


const { t } = useI18n();
const swal = inject("$swal");

const selectGroup = ref(false);
const selectType = ref(false);

const images = ref([])

///// computed
const save = computed(() => t("buttons.save"));
const cancel = computed(() => t("buttons.canc"));
const approve = computed(() => t("buttons.apprv"));
const reject = computed(() => t("buttons.rejec"));

const listQ03 = ref([]);
const listQ03O = ref([]);

const listprint = ref([]);

const listQ03E = ref({});
const listQ03D = ref([]);
const uid_edit = ref('');


const balweight = ref(0);
const balweight_s = ref('');

const balprice = ref(0);
const balprice_s = ref('');

const balfull = ref(0);
const balfull_s = ref('');

const diff = ref(0);
const diff_s = ref('');


const listinfo = ref([]);
const listinfo_coll = ref([]);
const tk_status = ref('');
const int_cal = ref(0);
const paymentE = ref('');
const shop_detail = ref({})
const payment_l = ref([])
const int_period = ref('');
const dep_ref = ref('');
const dep_no = ref('');

const workItem_uid = ref('');
const workItem_version = ref(null);

const visible_g = ref(false)
const images_l = ref([])

const groupuid = ref("");
const typeTrans = ref("");

const dataCloverList = ref([])

const cus_detail = ref({
  uid: '',
  nameTh: '',
  nameEn: '',
  birthOrRegDate: new Date(),
  address: {
    address1: "",
    subDistrict: "",
    district: "",
    province: "",
    postcode: "",
    country: ""
  },
  issuedBy: '',
  issuedDate: new Date(),
  expiredDate: new Date(),
  version: '',
  age: 0,
  docTypeUid: '0',
  docNumber: '',
  cusShop: {
    cusTypeUid: "0",
    creditAmount: 0,
    email: "",
    phoneNo1: "",
    phoneNo2: "",
    phoneNo3: "",
  }
})

const workcaseDetail = ref(null);
const interestRate_s = ref('');

const isValid = ref(undefined)
const paused = ref(true)
const result = ref(null)
const error = ref('')

const qr_serach = ref('');
const qr_worckcaseUid = ref('');
const qr_serach2 = ref('');
const qr_worckcaseUid2 = ref('');

const loading = ref(false);
const hideCam = ref(false);
const photoFile = ref([]);

const thumb_id = ref("");
const thumb = ref(null);
const preview = ref("");

const picWidth = ref(400);
const picHeight = ref(300);

const activeTab = ref('tab1');

const cusUid_search = ref('');
const cusName_search = ref('');

const promoint_duration = ref('');
const promoint_val = ref('');
const regex = /data:.*base64,/
const mimeType = ref("");
const thumb_name = ref('');
const listtk_images = ref([]);
const count_success = ref(0);
const err_msg = ref("");
const workcaseDetail_prv = ref(null);
const wfDeposit = ref(false);
const migtkDetail = ref(null);
const promotionDetail = ref(null);
const fcusdt = ref(false)
const bf_changename = ref('');
const af_changename = ref('');
const transdate_prv = ref(null);
const activeDetail = ref(null); // ตัวแปรกลางที่จะส่งให้ Modal

const formattedInterest = computed(() => {
  return formatNumberDecimalString(workcaseDetail.value.interestCalc);
});

const formattedDiscount = computed(() => {
  return formatNumberDecimalString(workcaseDetail.value.interestRef.calDiscount);
});

const openPrv = async (data) => {
  activeDetail.value = null;
  activeDetail.value = data; // เอาข้อมูล _prv มาใส่
  await nextTick();
  const modalElement = document.getElementById('lookupModal2');
  if (modalElement) {
    // ตรวจสอบว่ามี Instance เดิมอยู่ไหม ถ้ามีให้เอามาใช้ ถ้าไม่มีให้สร้างใหม่
    const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
    modalInstance.show();
  }
};

// ฟังก์ชันสำหรับเปิด Modal ตัวที่ 2
const openCurrent = async (data) => {
  activeDetail.value = null;
  activeDetail.value = data; // เอาข้อมูลปกติมาใส่
  await nextTick();
  const modalElement = document.getElementById('lookupModal2');
  if (modalElement) {
    // ตรวจสอบว่ามี Instance เดิมอยู่ไหม ถ้ามีให้เอามาใช้ ถ้าไม่มีให้สร้างใหม่
    const modalInstance = Modal.getInstance(modalElement) || new Modal(modalElement);
    modalInstance.show();
  }
};

const openCamera = () => {
  hideCam.value = true;
};

const savephotoTaken = async (data) => {
  hideCam.value = false;
  photoFile.value = data
}


const closeCamera = (data) => {
  hideCam.value = false;
  localStorage.removeItem("dataL");
  localStorage.removeItem("imageL");
};


async function addFile(e) {
  thumb.value = null
  preview.value = ""
  mimeType.value = ""
  thumb_name.value = ""
  if (e.target.files[0] !== undefined) {
    thumb.value = await toBase64(e.target.files[0])
    preview.value = URL.createObjectURL(e.target.files[0]);
    let today = moment(new Date()).local().format('YYYYMMDD_HHmmss')
    thumb_name.value = 'ticketimg_' + today
    if (e.target.files[0].type === "image/jpeg") {
      thumb_name.value = thumb_name.value + ".jpg"
      mimeType.value = "image/jpeg"
    } else if (e.target.files[0].type === "image/png") {
      thumb_name.value = thumb_name.value + ".png"
      mimeType.value = "image/png"
    }
  }

}

const toBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result.replace('data:', '')
    .replace(/^.+,/, ''));
  reader.onerror = reject;
});

const selectedConstraints = ref({ facingMode: 'environment' })

const defaultConstraintOptions = [
  { label: 'rear camera', constraints: { facingMode: 'environment' } },
  { label: 'front camera', constraints: { facingMode: 'user' } }
]
const constraintOptions = ref(defaultConstraintOptions)

/*** track functons ***/

function paintOutline(detectedCodes, ctx) {
  for (const detectedCode of detectedCodes) {
    const [firstPoint, ...otherPoints] = detectedCode.cornerPoints

    ctx.strokeStyle = 'red'

    ctx.beginPath()
    ctx.moveTo(firstPoint.x, firstPoint.y)
    for (const { x, y } of otherPoints) {
      ctx.lineTo(x, y)
    }
    ctx.lineTo(firstPoint.x, firstPoint.y)
    ctx.closePath()
    ctx.stroke()
  }
}
function paintBoundingBox(detectedCodes, ctx) {
  for (const detectedCode of detectedCodes) {
    const {
      boundingBox: { x, y, width, height }
    } = detectedCode

    ctx.lineWidth = 2
    ctx.strokeStyle = '#007bff'
    ctx.strokeRect(x, y, width, height)
  }
}
function paintCenterText(detectedCodes, ctx) {
  for (const detectedCode of detectedCodes) {
    const { boundingBox, rawValue } = detectedCode

    const centerX = boundingBox.x + boundingBox.width / 2
    const centerY = boundingBox.y + boundingBox.height / 2

    const fontSize = Math.max(12, (50 * boundingBox.width) / ctx.canvas.width)

    ctx.font = `bold ${fontSize}px sans-serif`
    ctx.textAlign = 'center'

    ctx.lineWidth = 3
    ctx.strokeStyle = '#35495e'
    ctx.strokeText(detectedCode.rawValue, centerX, centerY)

    ctx.fillStyle = '#5cb984'
    ctx.fillText(rawValue, centerX, centerY)
  }
}
const trackFunctionOptions = [
  { text: 'nothing (default)', value: undefined },
  { text: 'outline', value: paintOutline },
  { text: 'centered text', value: paintCenterText },
  { text: 'bounding box', value: paintBoundingBox }
]
const trackFunctionSelected = ref(trackFunctionOptions[1])


const loadDataQ03Api = async (val) => {
  let data = "";
  data = {
    index: '0',
    size: '100',
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storew.listQ03Fetch(payload);


  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list;
        let newL = []
        listd.map(function (x) {
          x.chk = false;
          x.start = null
          x.payside = null
          x.weight_s = ''
          x.quantity_s = ''
          x.newPawnValue_s = ''
          x.fullValue_s = ''
          x.interest_s = ''
          x.trans = null
          return x
        });
        for (let i = 0; i < listd.length; i++) {
          if (listd[i].weight !== null && listd[i].newPawnValue !== null
            && listd[i].fullValue !== null && listd[i].quantity !== null && listd[i].roundInterest !== null
            && listd[i].totalPay !== null && listd[i].totalReceive !== null) {
            // console.log("if 1 " + i + ' : ' + JSON.stringify(listd[i]));
            listd[i].start = format_datetime(new Date(listd[i].startTime))
            listd[i].payside = checkPaySide(listd[i].paySide)
            listd[i].weight_s = formatNumberDecimalString(listd[i].weight)
            listd[i].quantity_s = formatNumberDecimalString(listd[i].quantity)
            listd[i].newPawnValue_s = formatNumberDecimalString(listd[i].newPawnValue)
            listd[i].fullValue_s = formatNumberDecimalString(listd[i].fullValue)
            listd[i].interest_s = formatNumberDecimalString(listd[i].roundInterest)
            if (!listd[i].migration) {
              listd[i].trans = checkTransaction(listd[i].type)
            } else {
              listd[i].trans = checkTransaction(listd[i].type) + " (" + checkTransaction(listd[i].migrationType) + ")"
            }
            newL.push(listd[i])
          }
        }
        listQ03.value = newL
      }
    }
  }
}


const loadDataQ03OwnerApi = async (val) => {
  let data = "";
  data = {
    index: '0',
    size: '100',
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storew.listQ03OwnerFetch(payload);
  // console.log("response : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list;
        let newL = []
        listd.map(function (x) {
          x.chk = false;
          x.start = null
          x.payside = null
          x.weight_s = ''
          x.quantity_s = ''
          x.newPawnValue_s = ''
          x.fullValue_s = ''
          x.interest_s = ''
          x.trans = null
          return x
        });
        for (let i = 0; i < listd.length; i++) {
          if (listd[i].weight !== null && listd[i].newPawnValue !== null
            && listd[i].fullValue !== null && listd[i].quantity !== null && listd[i].roundInterest !== null
            && listd[i].totalPay !== null && listd[i].totalReceive !== null) {
            // console.log("if 2 " + i + ' : ' + JSON.stringify(listd[i]));
            listd[i].start = format_datetime(new Date(listd[i].startTime))
            listd[i].payside = checkPaySide(listd[i].paySide)
            listd[i].weight_s = formatNumberDecimalString(listd[i].weight)
            listd[i].quantity_s = formatNumberDecimalString(listd[i].quantity)
            listd[i].newPawnValue_s = formatNumberDecimalString(listd[i].newPawnValue)
            listd[i].fullValue_s = formatNumberDecimalString(listd[i].fullValue)
            listd[i].interest_s = formatNumberDecimalString(listd[i].roundInterest)
            if (!listd[i].migration) {
              listd[i].trans = checkTransaction(listd[i].type)
            } else {
              listd[i].trans = checkTransaction(listd[i].type) + " (" + checkTransaction(listd[i].migrationType) + ")"
            }
            newL.push(listd[i])
          }
        }
        listQ03O.value = newL
      }
    }
  }
}



loadDataQ03Api()


const loadDataPrintApi = async () => {
  // await new Promise((res) => setTimeout(res, 500));
  let data = "";
  data = {
    uid: "",
  };
  const payload = data;
  // const response = await store.dispatch("categorylistPrintFetch", payload);
  const response = await storec.categorylistPrintFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listprint.value = response.data.data;
        // console.log('Listdata : ' + JSON.stringify(listprint.value))
      }
    }
  }
};

const getshopInfo = async (val) => {
  shop_detail.value = {}
  const response = await storeca.cashaccountInfoFromSessionFetch();
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        shop_detail.value = response.data.data

      }
    }
  }
}

getshopInfo()

async function onClickTab(val) {
  if (val === '1') {
    activeTab.value = 'tab1';
    await loadDataQ03Api()
    await setfirstTab()
  } else if (val === '2') {
    activeTab.value = 'tab2';
    await loadDataQ03OwnerApi()
    await setsecondTab()
  } else if (val === '3') {
    activeTab.value = 'tab3';
    await setthirdTab()
  }
}

async function onSelectGroup() {
  // console.log('onSelectGroup : ' + selectGroup.value)
  if (!selectGroup.value) {
    groupuid.value = ''
    for (let i = 0; i < listQ03.value.length; i++) {
      listQ03.value[i].chk = false
    }
  }
}

async function onSelectType() {
  // console.log('onSelectType : ' + selectType.value)
  if (!selectType.value) {
    typeTrans.value = ''
    for (let i = 0; i < listQ03.value.length; i++) {
      listQ03.value[i].chk = false
    }
  }
}

async function onSelectListQ02(item) {

  if (selectGroup.value || selectType.value) {
    if (selectGroup.value) {

      if (item.chk) {
        groupuid.value = item.paymentGroupUid
      } else {
        groupuid.value = ''
      }

      for (let i = 0; i < listQ03.value.length; i++) {
        if (listQ03.value[i].paymentGroupUid === item.paymentGroupUid) {
          listQ03.value[i].chk = item.chk
        }
      }
    } else if (selectType.value) {

      if (item.chk) {
        typeTrans.value = item.type

      } else {
        typeTrans.value = ''
      }

      for (let i = 0; i < listQ03.value.length; i++) {
        if (listQ03.value[i].type === item.type) {
          listQ03.value[i].chk = item.chk
        }
      }
    }
  }
}

function copyBtn() {
  navigator.clipboard.writeText(workcaseDetail.value.tkRefNumber);
}

const NewTab = async () => {
  sessionStorage.removeItem('deferWorkcaseUid');
  sessionStorage.setItem("deferWorkcaseUid", workcaseDetail.value.uid);
  if (sessionStorage.getItem('deferWorkcaseUid') !== null) {
    const win = window.open("#/generals/defer_items", "_blank");
    win.focus();
    sessionStorage.removeItem('deferWorkcaseUid');
  }
}



function formatNumberString(num) {
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function formatNumberDecimalString(num) {
  if (num !== null && num !== undefined) {
    num = num.toFixed(2)
  } else {
    num = 0
    num = num.toFixed(2)
  }
  return String(num).replace(
    /(\d)(?=(\d{3})+(?!\d))/g,
    "$1,"
  );
}

function filterCanPrint(items) {
  const result = dataCloverList.value.some(item =>
    item.uid === items.uid
  )
  return result
}


function delCanPrint(items) {
  if (filterCanPrint(items)) {
    let filteredArr = dataCloverList.value.filter(e => e.uid !== items.uid)
    dataCloverList.value = filteredArr
    // console.log('delCanPrint : ' + JSON.stringify(dataCloverList.value));
  }

}



function filterCat(str) {
  let side = ''
  let name = listprint.value.filter((c) => c.uid === str);
  if (name.length > 0) {
    side = name[0].name
  }
  return side
}



function checkPaySide(str) {
  // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE

  let side = ''
  if (str === 'PAY') {
    side = 'จ่ายเงิน'
  } else if (str === 'RECEIVE') {
    side = 'รับเงิน'
  } else if (str === 'NONE') {
    side = 'ไม่มียอด'
  }
  return side
}

function format_datetime(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY HH:mm:ss')
  }
}


function format_date(value) {
  if (value) {
    return moment(String(value)).local().format('DD/MM/YYYY')
  }
}

function checkTransaction(str) {
  // PAWN, INTEREST, REDEEM, INC_PRINCIPLE, DEC_PRINCIPLE
  let side = ''
  if (str === 'PAWN') {
    side = 'จำนำ'
  } else if (str === 'INTEREST') {
    side = 'ต่อดอกเบี้ย'
  } else if (str === 'REDEEM') {
    side = 'ไถ่ถอน'
  } else if (str === 'INC_PRINCIPLE') {
    side = 'เพิ่มต้น'
  } else if (str === 'DEC_PRINCIPLE') {
    side = 'ลดต้น'
  } else if (str === 'REVIEW_COLLATERAL') {
    side = 'ขอดูทรัพย์'
  }
  return side
}

function canEdit(item) {
  let bool = true
  if ((item.type === 'INC_PRINCIPLE' && item.step.code === 'S050')) {
    bool = false
  }

  if (item.step.code === 'S030' && item.step.name !== 'Re-Pack') {
    bool = false
  }


  return bool
}

function canKeep(item) {
  let bool = false

  if (item.type === 'REDEEM' || (item.step.code === 'S030' && item.step.name !== 'Re-Pack')) {
    bool = true
  }

  if (bool === false) {
    if (item.type === 'INC_PRINCIPLE' && item.step.code === 'S050') {
      bool = true
    }
  }



  return bool
}

function canCancel(item) {
  let bool = false

  if (item.type === 'REDEEM' || item.step.code === 'S030' || item.type === 'REVIEW_COLLATERAL') {
    bool = true
  }

  if (bool === false) {
    if (item.type === 'INC_PRINCIPLE') {
      if (item.step.code === 'S050' || item.step.code === 'S061' || item.step.code === 'S062') {
        bool = true
      }
    }
  }

  if (bool === false) {
    if (item.type === 'DEC_PRINCIPLE') {
      if (item.step.code === 'S051' || item.step.code === 'S061') {
        bool = true
      }
    }
  }

  return bool
}

function canPrint(item) {
  let bool = false
  if (item.type === 'REDEEM' || item.step.code === 'S030' || item.type === 'REVIEW_COLLATERAL') {
    bool = true
  }

  if (bool === false) {
    if (item.type === 'INC_PRINCIPLE') {
      if (item.step.code === 'S050' || item.step.code === 'S061' || item.step.code === 'S062') {
        bool = true
      }
    }
  }

  if (bool === false) {
    if (item.type === 'DEC_PRINCIPLE') {
      if (item.step.code === 'S051') {
        bool = true
      }
    }
  }


  return bool
}


async function chkSelect() {
  const submitButton = document.getElementById('lockTicket');
  submitButton.onclick = function (event) {
    if (event.detail > 1) {
      alert('You double-clicked the button!');
      // console.log('Double-click detected, ignoring.');
      return; // Prevent action on double-click
    }
    submitButton.disabled = true;
    let process = false
    let lockL = []
   for (let i = 0; i < listQ03.value.length; i++) {
    if (listQ03.value[i].chk) {
      process = true
      // console.log('chkSelect u : ' + JSON.stringify(listQ02.value[i].uid) + ' v : ' + JSON.stringify(listQ02.value[i].version));
      lockL.push({ uid: listQ03.value[i].uid, version: listQ03.value[i].version })

    }
  }

    if (!process) {
      swal({
        title: "กรุณาเลือกรายการ",
        text: "",
        icon: "error",
        allowOutsideClick: false,
        showCloseButton: false,
        showCancelButton: false,
        closeOnConfirm: false,
        focusConfirm: false,
        animation: "slide-from-top",
        confirmButtonText: t('buttons.conf'),
        cancelButtonText: t('buttons.canc'),
      }).then((result) => {
        if (result.isConfirmed) {
          return
        }
      });
    } else {
      // console.log('lockL : ' + JSON.stringify(lockL));
      lock(lockL, '')
    }
   }
  } 

async function onOpenQRModal() {
  qr_serach.value = ''
  qr_worckcaseUid.value = ''
  paused.value = false
  await resetValidationState()
  document.getElementById("qrModalShow").click();
}

/*** error handling ***/
function onError(err) {
  error.value = `[${err.name}]: `
  if (err.name === 'NotAllowedError') {
    error.value += 'you need to grant camera access permission'
  } else if (err.name === 'NotFoundError') {
    error.value += 'no camera on this device'
  } else if (err.name === 'NotSupportedError') {
    error.value += 'secure context required (HTTPS, localhost)'
  } else if (err.name === 'NotReadableError') {
    error.value += 'is the camera already in use?'
  } else if (err.name === 'OverconstrainedError') {
    error.value += 'installed cameras are not suitable'
  } else if (err.name === 'StreamApiNotSupportedError') {
    error.value += 'Stream API is not supported in this browser'
  } else if (err.name === 'InsecureContextError') {
    error.value +=
      'Camera access is only permitted in secure context. Use HTTPS or localhost rather than HTTP.'
  } else {
    error.value += err.message
  }

  // document.getElementById("closeqr").click();
  // paused.value = false
  // resetValidationState()
}

async function resetValidationState() {
  isValid.value = undefined
  result.value = ''
}


async function onDetect([firstDetectedCode]) {
  result.value = firstDetectedCode.rawValue
  paused.value = true
  // pretend it's taking really long
  await timeout(1500)
  isValid.value = result.value
  if (activeTab.value === 'tab1') {
    qr_serach.value = result.value
    await setResultQRTab1()
  } else if (activeTab.value === 'tab2') {
    qr_serach2.value = result.value
    await setResultQRTab2()
  }

  await resetValidationState()
  document.getElementById("closeqr").click();
  // some more delay, so users have time to read the message

}

function timeout(ms) {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms)
  })
}


async function setResultQRTab1() {

  if (qr_serach.value.trim() !== '' && listQ03.value.length > 0) {
    let lw = []
    if (qr_serach.value.length > 2) {
      // console.log("search tkRef : " + qr_serach.value);
      lw = listQ03.value.filter((c) => c.prevRefNumber === qr_serach.value);
    } else {
      // console.log("search trayId : " + qr_serach.value);
      lw = listQ03.value.filter((c) => c.trayId === qr_serach.value);
    }
    if (lw.length > 0) {
      // console.log('lw : ' + JSON.stringify(lw[0]))
      qr_worckcaseUid.value = lw[0].workCaseUid
      let lockL = []
      lockL.push({ uid: lw[0].uid, version: lw[0].version })
      await lock(lockL, 'auto')
    } else {
      swal("ไม่พบข้อมูล", "", "error");
    }
  }

}

async function setResultQRTab2() {
  // console.log('active 2 : ' + activeTab.value)
  if (qr_serach2.value.trim() !== '' && listQ03O.value.length > 0) {
    let lw = []
    if (qr_serach2.value.length > 2) {
      // console.log("search tkRef 2 : " + qr_serach.value);
      lw = listQ03O.value.filter((c) => c.prevRefNumber === qr_serach2.value || c.refNumber === qr_serach2.value);
    } else {
      // console.log("search trayId 2 : " + qr_serach.value);
      lw = listQ03O.value.filter((c) => c.trayId === qr_serach2.value);
    }
    if (lw.length > 0) {
      if (!canEdit(lw[0])) {
        qr_worckcaseUid2.value = lw[0].workCaseUid
        openTab(lw[0])
        qr_serach2.value = ''
        qr_worckcaseUid2.value = ''
      } else if (!canKeep(lw[0])) {
        qr_worckcaseUid2.value = lw[0].workCaseUid
        onKeep(lw[0])
        qr_serach2.value = ''
        qr_worckcaseUid2.value = ''
      }
    } else {
      swal("ไม่พบข้อมูล", "", "error");
    }
  }
}

async function findQ03Owner() {
  await loadDataQ03OwnerApi()
  if (listQ03O.value.length > 0) {
    let lw = []
    lw = listQ03O.value.filter((c) => c.workCaseUid === qr_worckcaseUid.value);
    if (lw.length > 0) {
      openTab(lw[0])
      qr_serach.value = ''
      qr_worckcaseUid.value = ''
    }
  }
}


async function clearItemCustomerInfo() {
  cus_detail.value = {
    uid: '',
    nameTh: '',
    nameEn: '',
    birthOrRegDate: new Date(),
    address: {
      address1: "",
      subDistrict: "",
      district: "",
      province: "",
      postcode: "",
      country: ""
    },
    issuedDate: new Date(),
    expiredDate: new Date(),
    version: '',
    age: 0,
    docTypeUid: '0',
    docNumber: '',
    cusShop: {
      cusTypeUid: "0",
      creditAmount: 0,
    }
  }
}

async function setCustomerInfo(item) {
  await getCustomerInfo(item.customerUid)
  if (cus_detail.value.phoneNo1 === null) {
    cus_detail.value.phoneNo1 = ""
  }
}

async function getCustomerInfo(uid) {

  let data = "";
  data = {
    uid: uid,
  };

  const payload = data;
  const response = await storecus.customerInfoFetch(payload);
  // console.log("getCustomerInfo : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        cus_detail.value = response.data.data
        // console.log("getCustomerInfo : " + JSON.stringify(cus_detail.value));
        // listcusbank.value = response.data.data.list;
      }
    }
  }
}


async function openTab(item) {
  // console.log('item : ' + JSON.stringify(item));
  if (listprint.value.length === 0) {
    await loadDataPrintApi()
  }
  workItem_uid.value = item.uid
  workItem_version.value = item.version
  images.value = []
  images_l.value = []
  listinfo_coll.value = []
  workcaseDetail.value = null
  interestRate_s.value = ''
  cusUid_search.value = ''
  cusName_search.value = ''
  promoint_duration.value = ''
  promoint_val.value = ''
  thumb.value = null
  preview.value = ""
  mimeType.value = ""
  thumb_name.value = ""
  photoFile.value = []
  int_period.value = ''
  int_cal.value = 0
  wfDeposit.value = false
  dep_no.value = ''
  migtkDetail.value = null
 
  clearItemCustomerInfo()
  await getworkCaseInfo(item.workCaseUid)
  await setCustomerInfo(workcaseDetail.value.customerInfo)
  if (workcaseDetail.value != null && cus_detail.value.uid !== '') {
    // console.log('workcaseDetail : ' + JSON.stringify(workcaseDetail.value));
    listQ03E.value = item
    images_l.value = workcaseDetail.value.ticket.images
    uid_edit.value = workcaseDetail.value.ticket.uid
    listinfo_coll.value = workcaseDetail.value.ticket.collateralInfo
    if (workcaseDetail.value.rlCustomerInfo !== null) {
      cusUid_search.value = workcaseDetail.value.rlCustomerInfo.customerUid
      cusName_search.value = workcaseDetail.value.rlCustomerInfo.name
    }
    diff.value = workcaseDetail.value.diffValue;
    diff_s.value = formatNumberString(diff.value);

    interestRate_s.value = formatNumberDecimalString(workcaseDetail.value.interestPerMonth)

    if (workcaseDetail.value.interestPromotion === null || workcaseDetail.value.interestPromotion === 0) {
      promoint_val.value = formatNumberDecimalString(0)
    } else {
      promoint_val.value = formatNumberDecimalString(workcaseDetail.value.interestPromotion)
    }
    if (workcaseDetail.value.promotionDuration === 0) {
      promoint_duration.value = '-'
    } else {
      promoint_duration.value = workcaseDetail.value.promotionDuration + ' เดือน'
    }

    if (listQ03E.value.prevRefNumber !== null && listQ03E.value.prevRefNumber !== '') {
      await getworkCaseInfoByRef(listQ03E.value.prevRefNumber)
      if (workcaseDetail_prv.value != null) {
          if (workcaseDetail_prv.value.deposit) {
               await getDepositInfo(workcaseDetail_prv.value.tkRefNumber)
          }
      } 
    }

    if (item.type === 'REDEEM') {
      item.newPawnValue = workcaseDetail.value.newPawnValue
      item.newPawnValue_s = formatNumberDecimalString(item.newPawnValue)
      balprice.value = workcaseDetail.value.pawnValue;
    } else {
      balprice.value = workcaseDetail.value.newPawnValue;
    }

    if (workcaseDetail.value.migrationUid !== null && workcaseDetail.value.migrationUid !== '' && workcaseDetail.value.migrationUid !== '0') {
      await migrationtkInfo(workcaseDetail.value.migrationUid)
      if (migtkDetail.value != null) { 
        listQ03D.value = workcaseDetail.value.ticket.collaterals
          var total = 0;
          for (let i = 0; i < listQ03D.value.length; i++) {
                total += listQ03D.value[i].weight
          }
          listQ03E.value.weight_s = formatNumberDecimalString(total)
          balweight.value = total
      }

    } else {
      listQ03D.value = workcaseDetail.value.ticket.collaterals
      balweight.value = item.weight;
    }

    listQ03D.value.map(function (x) {
      x.chk = false
      x.remarkL = []
      return x
    });
  }

  balfull.value = item.fullValue;

  if (listQ03D.value.length > 0) {
    for (let i = 0; i < listQ03D.value.length; i++) {
      balweight.value = balweight.value - listQ03D.value[i].weight
      balfull.value = balfull.value - listQ03D.value[i].fullValue
      listQ03D.value[i].remarkL.push({ val: listQ03D.value[i].remark })
      if (item.type === 'INC_PRINCIPLE' || item.type === 'DEC_PRINCIPLE') {
          balprice.value = balprice.value - listQ03D.value[i].tmpNewPawnValue
      } else {
          balprice.value = balprice.value - listQ03D.value[i].newPawnValue
      }
    }
  }

  if (balweight.value !== null) {
    balweight.value = balweight.value.toFixed(2)
  }

  if (balprice.value !== null) {
    balprice.value = balprice.value.toFixed(2)
  }

  if (balfull.value !== null) {
    balfull.value = balfull.value.toFixed(2)
  }

  balweight_s.value = formatNumberString(balweight.value);
  balprice_s.value = formatNumberString(balprice.value);
  balfull_s.value = formatNumberString(balfull.value);
  await setthirdTab()
}

async function getworkCaseInfo(id) {
  let data = "";
  data = {
    uid: id,
  };
  const payload = data;

  const response = await storewc.workCaseinfoFetch(payload);
  // console.log("getworkCaseInfo : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcaseDetail.value = response.data.data
      }
    }
  }
}




async function setfirstTab() {

  if (document.getElementById("second-home-tab")) {
    document.getElementById("second-home-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("secondHome")) {
    document.getElementById("secondHome").classList.remove('show', 'active')
  }

  if (document.getElementById("third-home-tab")) {
    document.getElementById("third-home-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("thirdHome")) {
    document.getElementById("thirdHome").classList.remove('show', 'active')
  }

  if (document.getElementById("first-home-tab")) {
    document.getElementById("first-home-tab").classList.add('show', 'active')
  }

  if (document.getElementById("firstHome")) {
    document.getElementById("firstHome").classList.add('show', 'active')
  }

}


async function setsecondTab() {

  if (document.getElementById("first-home-tab")) {
    document.getElementById("first-home-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("firstHome")) {
    document.getElementById("firstHome").classList.remove('show', 'active')
  }

  if (document.getElementById("third-home-tab")) {
    document.getElementById("third-home-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("thirdHome")) {
    document.getElementById("thirdHome").classList.remove('show', 'active')
  }

  if (document.getElementById("second-home-tab")) {
    document.getElementById("second-home-tab").classList.add('show', 'active')
  }

  if (document.getElementById("secondHome")) {
    document.getElementById("secondHome").classList.add('show', 'active')
  }
}

async function setthirdTab() {

  if (document.getElementById("first-home-tab")) {
    document.getElementById("first-home-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("firstHome")) {
    document.getElementById("firstHome").classList.remove('show', 'active')
  }

  if (document.getElementById("second-home-tab")) {
    document.getElementById("second-home-tab").classList.remove('show', 'active')
  }

  if (document.getElementById("secondHome")) {
    document.getElementById("secondHome").classList.remove('show', 'active')
  }

  if (document.getElementById("third-home-tab")) {
    document.getElementById("third-home-tab").classList.add('show', 'active')
  }

  if (document.getElementById("thirdHome")) {
    document.getElementById("thirdHome").classList.add('show', 'active')
  }

}

async function backToFirstTab() {
  uid_edit.value = ''
  workItem_uid.value = ''
  workItem_version.value = null
  images.value = []
  images_l.value = []
  listinfo_coll.value = []
  listQ03D.value = []
  balweight.value = 0;
  balprice.value = 0;
  balfull.value = 0;
  balweight_s.value = ''
  balprice_s.value = ''
  balfull_s.value = ''
  listQ03E.value = {}
  diff.value = 0
  diff_s.value = ''
  workcaseDetail.value = null
  interestRate_s.value = ''
  promoint_duration.value = ''
  promoint_val.value = ''
  wfDeposit.value = false
  dep_no.value = ''
  migtkDetail.value = null
  clearItemCustomerInfo()
  await onClickTab('1')
}


async function backToSecondTab() {
  uid_edit.value = ''
  workItem_uid.value = ''
  workItem_version.value = null
  images.value = []
  images_l.value = []
  listinfo_coll.value = []
  listQ03D.value = []
  balweight.value = 0;
  balprice.value = 0;
  balfull.value = 0;
  balweight_s.value = ''
  balprice_s.value = ''
  balfull_s.value = ''
  listQ03E.value = {}
  diff.value = 0
  diff_s.value = ''
  workcaseDetail.value = null
  interestRate_s.value = ''
  promoint_duration.value = ''
  promoint_val.value = ''
  wfDeposit.value = false
  dep_no.value = ''
  migtkDetail.value = null
  clearItemCustomerInfo()
  await onClickTab('2')
}


async function openGallery() {
  if (images.value.length === 0) {
    loading.value = true
    let url = []
    images.value = []
    for (let i = 0; i < images_l.value.length; i++) {
      if (images_l.value[i].imageUid !== "0") {
        url.push(String(st.url_api + "/doc-svc/document/info/" + images_l.value[i].imageUid));
      }
    }

    if (url.length > 0) {
      await getFile(url)
      if (images.value.length > 0) {
        setGallery()
        loading.value = false
        document.getElementById("myModalGallery").click();
      }
    }

  } else {
    setGallery()
    loading.value = false
    document.getElementById("myModalGallery").click();
  }


}



async function onReturnDialog() {
  swal({
    title: "แก้ไขรายการ",
    text: "คุณต้องการตีกลับรายการนี้",
    icon: "warning",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.conf'),
    cancelButtonText: t('buttons.canc'),
    preConfirm: () => {
      swal.getConfirmButton().disabled = true;
      return new Promise((resolve) => {
        setTimeout(() => {
          swal.getConfirmButton().disabled = false;
          resolve();
        }, 500);
      });
    }
  }).then((result) => {
    if (result.isConfirmed) {
      onReturn()
    }
  });
}


async function onCompleteDialog() {
  swal({
    title: "ตรวจสอบรายการ",
    text: "คุณต้องการอนุมัติรายการนี้",
    icon: "info",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.conf'),
    cancelButtonText: t('buttons.canc'),
    preConfirm: () => {
      swal.getConfirmButton().disabled = true;
      return new Promise((resolve) => {
        setTimeout(() => {
          swal.getConfirmButton().disabled = false;
          resolve();
        }, 500);
      });
    }
  }).then((result) => {
    if (result.isConfirmed) {
      onComplete()
    }
  });
}

async function onCompleteDWDialog() {
  if (workcaseDetail.value.deposit) {
    swal({
      title: "ตรวจสอบรายการ",
      html: `<b><span style='color:red'><u>คุณต้องการอนุมัติและถอนตั๋วรายการนี้</u></span></b>`,
      icon: "info",
      allowOutsideClick: false,
      showCloseButton: false,
      showCancelButton: true,
      closeOnConfirm: false,
      focusConfirm: false,
      animation: "slide-from-top",
      confirmButtonText: t('buttons.conf'),
      cancelButtonText: t('buttons.canc'),
      preConfirm: () => {
        swal.getConfirmButton().disabled = true;
        return new Promise((resolve) => {
          setTimeout(() => {
            swal.getConfirmButton().disabled = false;
            resolve();
          }, 500);
        });
      }
    }).then((result) => {
      if (result.isConfirmed) {
        updateWfDeposit()
      }
    });
  } else {
    swal({
      title: "ตรวจสอบรายการ",
      html: `<b><span style='color:red'><u>คุณต้องการอนุมัติและฝากตั๋วรายการนี้</u></span></b>`,
      icon: "info",
      allowOutsideClick: false,
      showCloseButton: false,
      showCancelButton: true,
      closeOnConfirm: false,
      focusConfirm: false,
      animation: "slide-from-top",
      confirmButtonText: t('buttons.conf'),
      cancelButtonText: t('buttons.canc'),
      preConfirm: () => {
        swal.getConfirmButton().disabled = true;
        return new Promise((resolve) => {
          setTimeout(() => {
            swal.getConfirmButton().disabled = false;
            resolve();
          }, 500);
        });
      }
    }).then((result) => {
      if (result.isConfirmed) {
        updateWfDeposit()
      }
    });
  }


}


async function onKeepDialog(item) {
  swal({
    title: "บันทึกรายการ",
    text: "คุณต้องการเก็บทรัพย์รายการนี้",
    icon: "info",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.conf'),
    cancelButtonText: t('buttons.canc'),
    preConfirm: () => {
      swal.getConfirmButton().disabled = true;
      return new Promise((resolve) => {
        setTimeout(() => {
          swal.getConfirmButton().disabled = false;
          resolve();
        }, 500);
      });
    }
  }).then((result) => {
    if (result.isConfirmed) {
      onKeep(item)
    }
  });
}

async function onCancelDialog() {
  swal({
    title: "ยกเลิกรายการ",
    text: "คุณต้องการยกเลิกรายการนี้",
    icon: "warning",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.conf'),
    cancelButtonText: t('buttons.canc'),
    preConfirm: () => {
      swal.getConfirmButton().disabled = true;
      return new Promise((resolve) => {
        setTimeout(() => {
          swal.getConfirmButton().disabled = false;
          resolve();
        }, 500);
      });
    }
  }).then((result) => {
    if (result.isConfirmed) {
      onCancel()
    }
  });
}

async function onUnLockDialog(item) {
  swal({
    title: "ปลดล็อกรายการ",
    text: "คุณต้องการปลดล็อกรายการนี้",
    icon: "warning",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.conf'),
    cancelButtonText: t('buttons.canc'),
    preConfirm: () => {
      swal.getConfirmButton().disabled = true;
      return new Promise((resolve) => {
        setTimeout(() => {
          swal.getConfirmButton().disabled = false;
          resolve();
        }, 500);
      });
    }
  }).then((result) => {
    if (result.isConfirmed) {
      onUnLock(item)
    }
  });
}

async function onCancelTicketDialog(item) {
  swal({
    title: "ยกเลิกตั๋ว",
    text: "คุณต้องการยกเลิกตั๋วรายการนี้",
    icon: "warning",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.conf'),
    cancelButtonText: t('buttons.canc'),
    preConfirm: () => {
      swal.getConfirmButton().disabled = true;
      return new Promise((resolve) => {
        setTimeout(() => {
          swal.getConfirmButton().disabled = false;
          resolve();
        }, 500);
      });
    }
  }).then((result) => {
    if (result.isConfirmed) {
      onCancelTicket(item)
    }
  });
}

async function onReturn() {
  // console.log('onReturn : ' + workItem_uid.value + " version : " + workItem_version.value);
  // await workItemInfo()
  let obj = {
    uid: workItem_uid.value,
    action: 'return',
    version: workItem_version.value,
    process: 'return'
  }
  await completeStep(obj)
}

async function onComplete() {
  // console.log('onComplete : ' + workItem_uid.value + " version : " + workItem_version.value);
  // await workItemInfo()
  let obj = {
    uid: workItem_uid.value,
    action: 'complete',
    version: workItem_version.value,
    process: 'complete'
  }
  if (photoFile.value.length > 0 || thumb.value !== null) {
    if (photoFile.value.length > 0) {
      count_success.value = 0
      err_msg.value = ''
      for (let i = 0; i < photoFile.value.length; i++) {
        await uploadfileApi(photoFile.value[i])
      }
      if (count_success.value === 0) {
        swal("เพิ่มรูปในตั๋วไม่สำเร็จ", err_msg.value, "error");
      } else {
        await getListTkImages()
        if (listtk_images.value.length > 0) {
          await completeStep(obj)
        } else {
          swal("กรุณาเพิ่มรูปในตั๋ว", '', "error");
        }
      }

    } else {
      if (thumb.value !== null) {
        await addfileApi(thumb.value)
        if (thumb_id.value !== '0' && thumb_id.value !== null) {
          await addTicketImage(obj)
        }
      }
    }
  } else {
    await getListTkImages()
    if (listtk_images.value.length > 0) {
      await completeStep(obj)
    } else {
      swal("กรุณาเพิ่มรูปในตั๋ว", '', "error");
    }
  }
}


async function onKeep(item) {
  let obj = {
    uid: item.uid,
    action: 'complete',
    version: item.version,
    process: 'keep'
  }
  await completeStep(obj)
  loadDataQ03OwnerApi();
}


async function onCancelTicket(item) {
  // console.log('onCancelTicket : ' + JSON.stringify(item.uid) + " version : " + JSON.stringify(item.version));
  let obj = {
    uid: item.uid,
    action: 'cancel_ticket',
    version: item.version,
    process: 'cancel_ticket'
  }
  await completeStep(obj)
  loadDataQ03OwnerApi();
}

async function onCancel() {
// await workItemInfo()
  let obj = {
    uid: workItem_uid.value,
    action: 'cancel',
    version: workItem_version.value,
    process: 'cancel'
  }
  await completeStep(obj)
}

async function onUnLock(item) {
  let lockL = []
  lockL.push({ uid: item.uid, version: item.version })
  await unlock(lockL)
}

async function completeStep(item) {
  let data = "";
  data = {
    uid: item.uid,
    action: item.action,
    version: item.version,
  };
  const payload = data;
  const response = await storew.completeStepFetch(payload);

  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        if (item.process !== 'keep' && item.process !== 'cancel_ticket') {
          if (item.process === 'complete' && listQ03E.value.type !== 'REDEEM') {
            await ticketGen(listQ03E.value)
          }
          if (item.process === 'complete' && listQ03E.value.type !== 'PAWN') {
            await backCoverGen(listQ03E.value)
          }
          if (item.process === 'complete' && listQ03E.value.type !== 'PAWN' && listQ03E.value.type !== 'REDEEM' && wfDeposit.value) {
            if (workcaseDetail_prv.value.deposit === false) {
              await replaceTicketGen(workcaseDetail_prv.value)
            }
          }
          await backToSecondTab()
        } else {
          delCanPrint(item)
        }
        swal("บันทึกสำเร็จ", "", "success");
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
        if (response.data.rtnDesc === 'object already modified') {
          backToSecondTab()
        }
      }
    }
  }
}

async function lock(item, val) {
  let data = "";
  data = {
    lock: item,
  };
  const payload = data;
  const response = await storew.lockFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        const submitButton = document.getElementById('lockTicket');
            submitButton.onclick = function () {
            submitButton.disabled = true;
        };
        selectGroup.value = false
        selectType.value = false
        await loadDataQ03Api()
        if (val === 'auto') {
          swal({
            title: "บันทึกสำเร็จ",
            text: "",
            type: "success",
            timer: 1000
          }).then(() => {
            findQ03Owner()
          })
        } else {
          swal("บันทึกสำเร็จ", "", "success");
        }
      } else {
        const submitButton = document.getElementById('lockTicket');
            submitButton.onclick = function () {
            submitButton.disabled = false;
        };
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}

async function unlock(item) {
  let data = "";
  data = {
    groupUid: "", // for platform
    shopUid: "", // for platform
    workItems: item,
  };
  const payload = data;
  const response = await storew.unlockFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        swal("บันทึกสำเร็จ", "", "success");
        if (workItem_uid.value !== '' && workItem_uid.value === item[0].uid) {
          backToSecondTab()
        } else {
          loadDataQ03OwnerApi()
        }
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
      }
    }
  }
}

async function ticketGen(item) {
  let uids = []
  uids.push(item.workCaseUid)
  await getticketNew(uids)
}

async function backCoverGen(item) {
  let uids = []
  uids.push(item.workCaseUid)
  await getbackcoverNew(uids)
}

async function replaceTicketGen(item) {
  let uids = []
  uids.push(item.uid)
  await getreplaceTicketNew(uids)

}

async function getticketNew(id) {
  loading.value = true
  let data = {
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    uids: id
  };
  const key = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
  const accessToken = key.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/docgen-svc/ticket/pdf`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  loading.value = false
  if (response.headers.get("content-type") === 'application/pdf') {
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank').focus();
  } else {
    swal("โหลด PDF ไม่สำเร็จ", "", "error");
  }
}

async function getbackcoverNew(id) {
  loading.value = true
  let data = {
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    uids: id
  };
  const key = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
  const accessToken = key.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/docgen-svc/backCover/pdf`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  loading.value = false
  if (response.headers.get("content-type") === 'application/pdf') {
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank').focus();
  } else {
    swal("โหลด PDF ไม่สำเร็จ", "", "error");
  }
}

async function getreplaceTicketNew(id) {
  loading.value = true
  let data = {
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    uids: id
  };
  const key = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
  const accessToken = key.accessToken;
  const response = await axios({
    method: 'POST',
    data: data,
    url: st.url_api + `/docgen-svc/ticket/replace/pdf`,
    headers: { Authorization: `Bearer ${accessToken}` },
    responseType: 'arraybuffer',
  });
  loading.value = false
  if (response.headers.get("content-type") === 'application/pdf') {
    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank').focus();
  } else {
    swal("โหลด PDF ไม่สำเร็จ", "", "error");
  }
}


function setGallery() {
  var i, y = "";
  for (i = 0; i < images.value.length; i++) {
    if (i == 0) {
      y = y + '<button type = "button" data-bs-target="#lookupImages" data-bs-slide-to="' + String(i) + '"' +
        ' class="active" aria-current="true" aria-label="Slide ' + Number(i + 1) + '"> </button >';
    } else {
      y = y + '<button type = "button" data-bs-target="#lookupImages" data-bs-slide-to="' + String(i) + '"' +
        ' aria-label="Slide ' + Number(i + 1) + '"> </button >';
    }
  }
  document.getElementById("demo1").innerHTML = y;
}

async function getFile(urls) {
  let file_L = []
  const key = JSON.parse(localStorage.getItem("FR-SDK-nvtx-boapp"));
  const accessToken = key.accessToken;
  axios.defaults.headers["Authorization"] = `Bearer ${accessToken}`;
  const requests = urls.map((url) => axios.get(url));
  await Promise.all(requests).then(allResults => {
    if (allResults) {
      file_L = allResults
      if (file_L !== null) {
        for (let i = 0; i < file_L.length; i++) {
          if (file_L[i].data.data !== null) {
            // console.log('file_L : ' + JSON.stringify(file_L[i].data.data));
            const file = getFileFromBase64(file_L[i].data.data.data, file_L[i].data.data.name)
            const data = URL.createObjectURL(file);
            let ref = '-'
            if (listQ03E.value.prevRefNumber !== '' && listQ03E.value.prevRefNumber !== null) {
              ref = listQ03E.value.prevRefNumber
            }
            let obj = {
              src: data,
              thumbnailImageSrc: data,
              alt: '',
              title: '',
              cusnameTh: cus_detail.value.nameTh,
              refnumber: ref
            }
            images.value.push(obj)
          }
        }
      }
    }
  })

}


function getFileFromBase64(string64, fileName) {
  const trimmedString = string64.replace('dataimage/jpegbase64', '');
  const imageContent = atob(trimmedString);
  const buffer = new ArrayBuffer(imageContent.length);
  const view = new Uint8Array(buffer);

  for (let n = 0; n < imageContent.length; n++) {
    view[n] = imageContent.charCodeAt(n);
  }
  var ext = fileName.split('.').pop();
  let type = '';
  if (ext === 'jpg') {
    type = 'image/jpeg'
  } else if (ext === 'png') {
    type = 'image/png'
  }
  const blob = new Blob([buffer], { type });
  return new File([blob], fileName, { lastModified: new Date().getTime(), type });
}

async function addfileApi(fileInput) {
  thumb_id.value = '0'
  let data = "";
  let trimmedString = String(fileInput).replace(regex, "")

  data = {
    name: thumb_name.value,
    mimeType: mimeType.value,
    data: trimmedString,
  };

  const payload = data;
  // console.log('addfileApi p : ' + JSON.stringify(payload));
  const response = await stored.addFetch(payload);
  // console.log('addfileApi r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc !== "success") {
        swal("บันทึกไฟล์ไม่สำเร็จ", response.data.rtnDesc, "error");
      } else {
        thumb_id.value = response.data.data.uid
        // console.log('thumb_id : ' + thumb_id.value);
      }
    }
  }
}


async function addTicketImage(obj) {
  let data = "";
  data = {
    ticketUid: uid_edit.value, // always required
    uid: "0",
    imageUid: thumb_id.value,
    remark: "",
    version: "0"
  };

  const payload = data;
  const response = await storeti.ticketImageNewFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc !== "success") {
        swal("เพิ่มรูปในตั๋วไม่สำเร็จ", response.data.rtnDesc, "error");
      } else {
        if (obj.action === 'complete' && obj.process === 'complete') {
          await getListTkImages()
          if (listtk_images.value.length > 0) {
            await completeStep(obj)
          } else {
            swal("กรุณาเพิ่มรูปในตั๋ว", '', "error");
          }
        } else {
          await completeStep(obj)
        }
      }
    }
  }
}


async function onImgDialog() {
  swal({
    title: "",
    text: "คุณต้องการเพิ่มภาพจาก",
    icon: "info",
    allowOutsideClick: false,
    showCloseButton: false,
    showCancelButton: true,
    closeOnConfirm: false,
    focusConfirm: false,
    animation: "slide-from-top",
    confirmButtonText: t('buttons.conf'),
    cancelButtonText: t('buttons.canc'),
    input: 'select',
    inputOptions: {
      'Camera': 'ถ่ายภาพ',
      'File': 'แนบไฟล์ภาพถ่าย',
    },
    inputPlaceholder: 'กรุณาเลือก',
    inputValidator: function (value) {
      return new Promise(function (resolve, reject) {
        if (value === 'Camera') {
          resolve()
          thumb.value = null
          preview.value = ''
          photoFile.value = []
          setFileGallery('photo')
        } else if (value === 'File') {
          thumb.value = null
          preview.value = ''
          photoFile.value = []
          document.getElementById("upload").value = null;
          resolve()
          setFileGallery('file')
        } else {
          resolve("กรุณาเลือกรายการ :)");
        }
      })
    }
  });
}

async function openDetail(item) {
  workcaseDetail.value = null
  images.value = []
  images_l.value = []
  listinfo.value = []
  tk_status.value = ''
  paymentE.value = ''
  int_period.value = ''
  int_cal.value = 0
  dep_ref.value = ''
  promotionDetail.value = null
  bf_changename.value = ''
  af_changename.value = ''
  transdate_prv.value = null

  await getworkCaseInfo(item.workCaseUid)
  if (workcaseDetail.value != null) {
    // console.log('workcaseDetail : ' + JSON.stringify(workcaseDetail.value.status));
    if (workcaseDetail.value.changeName ) {
      af_changename.value = item.cusName
      await getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
    }else { 
      if (workcaseDetail.value.transactionType !== 'PAWN') { 
          await getworkCaseInfoPrv(workcaseDetail.value.prevRefNumber)
      }
    }
    if (workcaseDetail.value.deposit) {
      await getDepositInfo(workcaseDetail.value.tkRefNumber)
    }
    await detailPayment(workcaseDetail.value.paymentGroupUid)
    images_l.value = workcaseDetail.value.ticket.images
    listinfo.value = workcaseDetail.value.ticket.collaterals

    if (workcaseDetail.value.transactionType !== 'REDEEM') {
      if(workcaseDetail.value.latest){
              await calIntInt()
      }
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ปกติ'
      } else if (workcaseDetail.value.status === 'FREEZE') {
        tk_status.value = 'อายัด'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      } else if (workcaseDetail.value.status === 'ACTIVE') {
        tk_status.value = 'กำลังดำเนินการ'
      } else if (workcaseDetail.value.status === 'BREAKING') {
        tk_status.value = 'ของหลุด'
      }

    } else {
      // await getworkCaseInfoByRef(item.prevRefNumber)
      if (workcaseDetail.value.status === 'FINISH') {
        tk_status.value = 'ไถ่ถอน'
      } else if (workcaseDetail.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      }
    }
    
    if (workcaseDetail.value.promotionUid !== '0') { 
        await retrieveInfo(workcaseDetail.value)
    }

    if (images_l.value.length > 0) {
      getTicketImage('')
    } else {
      let obj = {
        src: noImg,
        thumbnailImageSrc: noImg,
        alt: '',
        title: ''
      }
      images.value.push(obj)
      openCurrent(workcaseDetail.value)
    }
  }
}


async function calIntInt() {
  // console.log('workcaseDetail : ' + JSON.stringify(workcaseDetail.value));
  let postponeDate = ''
  if (workcaseDetail.value.postponeCount != 0) {
    postponeDate = moment(workcaseDetail.value.postponeDate).format('YYYY-MM-DD')
  }
  let data = "";
  let pawnValue = 0
  if (workcaseDetail.value.transactionType != 'REDEEM') {
    pawnValue = workcaseDetail.value.newPawnValue
  } else {
    pawnValue = workcaseDetail.value.pawnValue
  }

  let cusUid = workcaseDetail.value.customerInfo.customerUid
  
    if(workcaseDetail.value.represent || workcaseDetail.value.shopRepresent){
       cusUid =  workcaseDetail.value.tkCustomerInfo.customerUid 
    }
  
  data = {
    cusUid: cusUid,
    txType: workcaseDetail.value.transactionType,
    pawnDate: moment(workcaseDetail.value.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    postponeDate: postponeDate,
    pawnValue: pawnValue,
    promotionUid: workcaseDetail.value.promotionUid,
    interestUid: workcaseDetail.value.interestUid,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestCalculateFetch(payload);
  // console.log("calIntInt r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        int_cal.value = Number(res.overdueInterest) + Number(res.dueInterest)
        int_period.value = res.interestPeriod
      }
    }
  }
}

async function detailPayment(item) {
  // console.log('detailPayment : ' + item);
  let data = "";
  data = {
    uid: item,
  };
  const payload = data;
  const response = await storep.paymentGroupinfoFetch(payload);

  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        paymentE.value = response.data.data
        filterPayType()
        // console.log('detailPayment : ' + JSON.stringify(paymentE.value));
      }
    }
  }
}


async function getTicketImage(val) {
  if (images.value.length === 0) {
    let url = []
    images.value = []
    for (let i = 0; i < images_l.value.length; i++) {
      if (images_l.value[i].imageUid !== "0") {
        url.push(String(st.url_api + "/doc-svc/document/info/" + images_l.value[i].imageUid));
      }
    }
    if (url.length > 0) {
      await getFile(url)
      if (images.value.length > 0) {
        if (val === 'prv') {
         openPrv(workcaseDetail_prv.value)
        } else {
         openCurrent(workcaseDetail.value)
        }
      } else {
        let obj = {
          src: noImg,
          thumbnailImageSrc: noImg,
          alt: '',
          title: ''
        }
        images.value.push(obj)
        if (val === 'prv') {
         openPrv(workcaseDetail_prv.value)
        } else {
         openCurrent(workcaseDetail.value)
        }
      }
    } else {
      let obj = {
        src: noImg,
        thumbnailImageSrc: noImg,
        alt: '',
        title: ''
      }
      images.value.push(obj)
      if (val === 'prv') {
         openPrv(workcaseDetail_prv.value)
      } else {
         openCurrent(workcaseDetail.value)
      }
    }
  } else {
    if (val === 'prv') {
        openPrv(workcaseDetail_prv.value)
      } else {
        openCurrent(workcaseDetail.value)
    }
  }
}


function filterPayType() {
  payment_l.value = []
  let pt = [{ name: 'CASH' },
  { name: 'BANK_TRANSFER' },
  { name: 'CREDIT_CARD' },
  { name: 'CHEQUE' },
  { name: 'PROMPT_PAY_MOBILE' },
  { name: 'PROMPT_PAY_TAX_ID' },
  { name: 'QR_CODE' },
  ]
  let lsum = []
  for (let i = 0; i < pt.length; i++) {
    lsum = filterSumPay(pt[i].name)
    if (lsum.length > 0) {
      payment_l.value.push({ name: pt[i].name, pay: lsum[0].pay, receive: lsum[0].receive, fee: lsum[0].fee })
    } else {
      payment_l.value.push({ name: pt[i].name, pay: 0, receive: 0, fee: 0 })
    }
  }
}

function filterSumPay(str) {
  let nump = 0, numr = 0, numf = 0
  let lp = paymentE.value.payments.filter((c) => c.type === str);
  if (lp.length > 0) {
    let pay = 0
    let receive = 0
    let fee = 0
    for (let i = 0; i < lp.length; i++) {
      pay = pay + lp[i].pay
      receive = receive + lp[i].receive
      fee = fee + lp[i].feeReceive
      // fee = fee + lp[i].fee
    }
    nump = pay
    numr = receive
    numf = fee
  }
  let lockL = []
  lockL.push({ pay: nump, receive: numr, fee: numf })
  // console.log('lockL : ' + JSON.stringify(lockL));
  return lockL
}


async function setFileGallery(val) {
  if (images.value.length === 0) {
    loading.value = true
    let url = []
    images.value = []
    for (let i = 0; i < images_l.value.length; i++) {
      if (images_l.value[i].imageUid !== "0") {
        url.push(String(st.url_api + "/doc-svc/document/info/" + images_l.value[i].imageUid));
      }
    }

    if (url.length > 0) {
      await getFile(url)
      if (images.value.length > 0) {
        loading.value = false
        if (val === 'photo') {
          let dtL = []
          let ref = '-'
            if (listQ03E.value.prevRefNumber !== '' && listQ03E.value.prevRefNumber !== null) {
                  ref = listQ03E.value.prevRefNumber
            }
            let obj = {
              cusnameTh: cus_detail.value.nameTh,
              refnumber: ref
            }
          dtL.push(obj)
          localStorage.setItem("dataL", JSON.stringify(dtL));
          localStorage.setItem("imageL", JSON.stringify(images.value));
          openCamera()
        } else if (val === 'file') {
          document.getElementById("attachmenDialog").click();
        }
      }
    } else {
      loading.value = false
      if (val === 'photo') {
        let dtL = []
        let ref = '-'
          if (listQ03E.value.prevRefNumber !== '' && listQ03E.value.prevRefNumber !== null) {
            ref = listQ03E.value.prevRefNumber
          }
          let obj = {
            cusnameTh: cus_detail.value.nameTh,
            refnumber: ref
          }
        dtL.push(obj)
        localStorage.setItem("dataL", JSON.stringify(dtL));
        localStorage.setItem("imageL", JSON.stringify(images.value));
        openCamera()
      } else if (val === 'file') {
        document.getElementById("attachmenDialog").click();
      }
    }

  } else {
    loading.value = false
    if (val === 'photo') {
      let dtL = []
      let ref = '-'
        if (listQ03E.value.prevRefNumber !== '' && listQ03E.value.prevRefNumber !== null) {
            ref = listQ03E.value.prevRefNumber
        }
        let obj = {
          cusnameTh: cus_detail.value.nameTh,
          refnumber: ref
        }
      dtL.push(obj)
      localStorage.setItem("dataL", JSON.stringify(dtL));
      localStorage.setItem("imageL", JSON.stringify(images.value));
      openCamera()
    } else if (val === 'file') {
      document.getElementById("attachmenDialog").click();
    }
  }
}


async function getListTkImages() {
  listtk_images.value = []
  let data = "";
  data = {
    index: 0,
    size: '100',
    tuid: uid_edit.value
  };

  const payload = data;
  // console.log("payload : " + JSON.stringify(payload));
  const response = await storeti.ticketImageListFetch(payload);
  // console.log("loadDataApi : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        listtk_images.value = response.data.data.list;
      }
    }
  }
}

async function uploadfileApi(image) {
  thumb_id.value = ""
  let data = "";
  let trimmedString = String(image.filedt).replace(regex, "")

  data = {
    name: image.fname,
    data: trimmedString,
    mimeType: image.ftype
  };

  const payload = data;
  // console.log('addfileApi p : ' + JSON.stringify(payload));
  const response = await stored.addFetch(payload);
  // console.log('addfileApi r : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc !== "success") {
        err_msg.value = response.data.rtnDesc
      } else {
        thumb_id.value = response.data.data.uid
        if (thumb_id.value !== '') {
          await uploadTicketimage()
        }
      }
    }
  }
}

async function uploadTicketimage() {
  let data = "";
  data = {
    ticketUid: uid_edit.value, // always required
    uid: "0",
    imageUid: thumb_id.value,
    remark: "",
    version: "0"
  };

  const payload = data;
  const response = await storeti.ticketImageNewFetch(payload);

  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc !== "success") {
        err_msg.value = response.data.rtnDesc
      } else {
        count_success.value = Number(count_success.value) + 1
      }
    }
  }
}

async function updateWfDeposit() {
  await getworkCaseInfo(listQ03E.value.workCaseUid)
  let data = "";
  wfDeposit.value = false
  if (workcaseDetail.value.deposit === false) {
    wfDeposit.value = true
  }
  data = {
    workCaseUid: workcaseDetail.value.uid,
    wfDeposit: wfDeposit.value,
    version: workcaseDetail.value.version,
  };
  const payload = data;
  const response = await storewc.updateWfDepositFetch(payload);
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcaseDetail.value = response.data.data
        await onComplete()
      } else {
        swal("บันทึกไม่สำเร็จ", response.data.rtnDesc, "error");
        if (response.data.rtnDesc === 'object already modified') {
          backToSecondTab()
        }
      }
    }
  }

}



async function openDetailPrv() {
  workcaseDetail_prv.value = null
  images.value = []
  images_l.value = []
  listinfo.value = []
  tk_status.value = ''
  paymentE.value = ''
  int_period.value = ''
  int_cal.value = 0
  dep_ref.value = ''
  promotionDetail.value = null
  bf_changename.value = ''
  af_changename.value = ''
  transdate_prv.value = null

  await getworkCaseInfoByRef(listQ03E.value.prevRefNumber)
  if (workcaseDetail_prv.value != null) {
    // console.log('workcaseDetail : ' + JSON.stringify(workcaseDetail.value.status));
    if (workcaseDetail_prv.value.changeName ) {
      af_changename.value = workcaseDetail_prv.value.tkCustomerInfo.name
      await getworkCaseInfoPrv(workcaseDetail_prv.value.prevRefNumber)
    }else { 
      if (workcaseDetail_prv.value.transactionType !== 'PAWN') { 
          await getworkCaseInfoPrv(workcaseDetail_prv.value.prevRefNumber)
      }
    }

    if (workcaseDetail_prv.value.deposit) {
      await getDepositInfo(workcaseDetail_prv.value.tkRefNumber)
    }

    await detailPayment(workcaseDetail_prv.value.paymentGroupUid)
    images_l.value = workcaseDetail_prv.value.ticket.images
    listinfo.value = workcaseDetail_prv.value.ticket.collaterals
    if (workcaseDetail_prv.value.transactionType !== 'REDEEM') {
      if (workcaseDetail_prv.value.status === 'FINISH') {
        tk_status.value = 'ปกติ'
      } else if (workcaseDetail_prv.value.status === 'FREEZE') {
        tk_status.value = 'อายัด'
      } else if (workcaseDetail_prv.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      } else if (workcaseDetail_prv.value.status === 'ACTIVE') {
        tk_status.value = 'กำลังดำเนินการ'
      } else if (workcaseDetail_prv.value.status === 'BREAKING') {
        tk_status.value = 'ของหลุด'
      }

    } else {
      if (workcaseDetail_prv.value.status === 'FINISH') {
        tk_status.value = 'ไถ่ถอน'
      } else if (workcaseDetail_prv.value.status === 'TERMINATE') {
        tk_status.value = 'ยกเลิก'
      }
    }

    if (workcaseDetail_prv.value.promotionUid !== '0') { 
        await retrieveInfo(workcaseDetail_prv.value)
    }

    if (images_l.value.length > 0) {
      getTicketImage('prv')
    } else {
      let obj = {
        src: noImg,
        thumbnailImageSrc: noImg,
        alt: '',
        title: ''
      }
      images.value.push(obj)
      openPrv(workcaseDetail_prv.value)
    }
  }
}


async function getworkCaseInfoByRef(prevRefNumber) {
  workcaseDetail_prv.value = null
  let data = "";
  data = {
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    refNumber: prevRefNumber,
  };
  const payload = data;

  const response = await storewc.workCaseInfoByRefFetch(payload);
  // console.log("getworkCaseInfo : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcaseDetail_prv.value = response.data.data
        await calIntIntPrv();
      }
    }
  }
}


async function calIntIntPrv() {
  // console.log('workcaseDetail : ' + JSON.stringify(workcaseDetail.value));
  let postponeDate = ''
  if (workcaseDetail_prv.value.postponeCount != 0) {
    postponeDate = moment(workcaseDetail_prv.value.postponeDate).format('YYYY-MM-DD')
  }
  let data = ""
  let pawnValue = 0
    if (workcaseDetail_prv.value.transactionType != 'REDEEM') {
        pawnValue = workcaseDetail_prv.value.newPawnValue
    } else {
        pawnValue = workcaseDetail_prv.value.pawnValue
    }

  let cusUid = workcaseDetail_prv.value.customerInfo.customerUid

  if(workcaseDetail_prv.value.represent || workcaseDetail_prv.value.shopRepresent){
     cusUid =  workcaseDetail_prv.value.tkCustomerInfo.customerUid 
  }
  
  data = {
    cusUid: cusUid,
    txType: workcaseDetail_prv.value.transactionType,
    pawnDate: '',
    previousTxDate: moment(workcaseDetail_prv.value.workItems[0].startTime).format('YYYY-MM-DD'),
    postponeDate: postponeDate,
    pawnValue: pawnValue,
    promotionUid: workcaseDetail_prv.value.promotionUid,
    interestUid: workcaseDetail_prv.value.interestUid,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestCalculateFetch(payload);
  // console.log("calIntInt r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        int_cal.value = Number(res.overdueInterest) + Number(res.dueInterest)
        int_period.value = res.interestPeriod
      }
    }
  }
}


async function getDepositInfo(tkRef) {
  let data = "";
  data = {
    index: 0,
    size: 1,
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    cusUid: '',
    refNumber: '',
    tkRefNumber: tkRef.trim(),
    channel: '',
    txDate: 0,
  };
  const payload = data;
  // console.log("ld p : " + JSON.stringify(payload));
  const response = await storedepo.listDepositFetch(payload);
  // console.log("ld r : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        let listd = response.data.data.list
        dep_ref.value = listd[0].refNumber
        dep_no.value = listd[0].refNumber
      }
    }
  }
}

async function openDetailPayment() {
  paymentE.value = '' 
  await detailPayment(workcaseDetail.value.paymentGroupUid)
  document.getElementById("paymentModal2").click();
}


async function migrationtkInfo(uid) {
  migtkDetail.value = null
  let data = "";
  data = {
    uid: uid,
  };
  const payload = data;
  // console.log('payload : ' + JSON.stringify(payload));
  const response = await storemigtk.mgtInfoFetch(payload);
  // console.log('response : ' + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
          migtkDetail.value = response.data.data
          // console.log('migtkDetail : ' + JSON.stringify(migtkDetail.value));
      }
    }
  }
}

async function retrieveInfo(item) {
  promotionDetail.value = null
  let data = "";
  let pawnValue = 0
  if (item.transactionType != 'REDEEM') {
      pawnValue = item.newPawnValue
  } else {
      pawnValue = item.pawnValue
  }
  
  let cusUid = item.customerInfo.customerUid

  if(item.represent || item.shopRepresent){
     cusUid =  item.tkCustomerInfo.customerUid 
  }

  data = {
    cusUid : cusUid,
    pawnDate: moment(item.workItems[0].startTime).format('YYYY-MM-DD'),
    previousTxDate: '',
    pawnValue: pawnValue,
  };
  const payload = data;
  // console.log("calIntInt p : " + JSON.stringify(payload));
  const response = await storei.interestRetrieveFetch(payload);
  // console.log("retrieveInfo r : " + JSON.stringify(response.data));
  let res = ''
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        res = response.data.data
        const result = res.interests.flatMap(item => {
        // เงื่อนไข: เป็นโปรโมชัน และ periodMonths > 1
        if (item.promotion === true && item.periodMonths > 1) {
          // สร้าง Array ใหม่ที่มีจำนวน element เท่ากับ periodMonths และใส่ข้อมูล item ลงไป
          return Array.from({ length: item.periodMonths }, () => ({ ...item }));
        }
        // หากไม่ตรงเงื่อนไข ให้คืนค่าเดิมกลับไป 1 ชุด
        return [item];
        });
        // console.log('result : ' + JSON.stringify(result));
      res.interests  =  result
      promotionDetail.value = res
      // console.log('promotionDetail : ' + JSON.stringify(promotionDetail.value));
      }
    }
  }
}

async function getworkCaseInfoPrv(prevRefNumber) {
  let workcase_prv = null
  let data = "";
  data = {
    groupUid: shop_detail.value.groupUid,
    shopUid: shop_detail.value.uid,
    refNumber: prevRefNumber,
  };
  const payload = data;

  const response = await storewc.workCaseInfoByRefFetch(payload);
  //  console.log("workCaseInfoByRef : " + JSON.stringify(response.data));
  if (response) {
    if (response.status === 200) {
      if (response.data.rtnDesc === "success") {
        workcase_prv = response.data.data
        bf_changename.value = workcase_prv.tkCustomerInfo.name 
        transdate_prv.value = workcase_prv.workItems[0].startTime
      }
    }
  }
}


onMounted(() => {
  
    if (document.getElementById("lockTicket")) {
    document.getElementById("lockTicket").onclick = function() {
      // console.log('lockTicket Clicked');
    };
  }

  if (document.getElementById("choices-gender")) {
    var gender = document.getElementById("choices-gender");
    new Choices(gender);
  }

  if (document.getElementById("choices-language")) {
    var language = document.getElementById("choices-language");
    new Choices(language);
  }

  if (document.getElementById("choices-month")) {
    var month = document.getElementById("choices-month");
    setTimeout(function () {
      new Choices(month);
    }, 1);

    // eslint-disable-next-line no-unused-vars
    var d = new Date();
    var monthArray = new Array();
    monthArray[0] = "January";
    monthArray[1] = "February";
    monthArray[2] = "March";
    monthArray[3] = "April";
    monthArray[4] = "May";
    monthArray[5] = "June";
    monthArray[6] = "July";
    monthArray[7] = "August";
    monthArray[8] = "September";
    monthArray[9] = "October";
    monthArray[10] = "November";
    monthArray[11] = "December";
    for (let m = 0; m <= 11; m++) {
      var optn = document.createElement("OPTION");
      optn.text = monthArray[m];
      // server side month start from one\
      optn.value = m + 1;
      // if june selected
      if (m == 1) {
        optn.selected = true;
      }
      month.options.add(optn);
    }
  }

  if (document.getElementById("choices-day")) {
    var day = document.getElementById("choices-day");
    setTimeout(function () {
      new Choices(day);
    }, 1);

    for (let y = 1; y <= 31; y++) {
      var optn1 = document.createElement("OPTION");
      optn1.text = y;
      optn1.value = y;

      if (y == 1) {
        optn1.selected = true;
      }

      day.options.add(optn1);
    }
  }

  if (document.getElementById("choices-year")) {
    var year = document.getElementById("choices-year");
    setTimeout(function () {
      new Choices(year);
    }, 1);

    for (let y = 1900; y <= 2020; y++) {
      var optn2 = document.createElement("OPTION");
      optn2.text = y;
      optn2.value = y;

      if (y == 2020) {
        optn.selected = true;
      }

      year.options.add(optn2);
    }
  }

  if (document.getElementById("choices-skills")) {
    var skills = document.getElementById("choices-skills");
    new Choices(skills, {
      delimiter: ",",
      editItems: true,
      maxItemCount: 5,
      removeItemButton: true,
      addItems: true,
    });
  }
  if (document.getElementById("first-home-tab")) {
    document.getElementById("first-home-tab").classList.add('show', 'active')
  }

  if (document.getElementById("firstHome")) {
    document.getElementById("firstHome").classList.add('show', 'active')
  }

});
</script>

<style lang="scss" scoped>
.review {
  border: 2px solid #1a73e8;
  border-radius: 6px;
  background: #d9e9ff;
}

.left {
  display: flex;
  justify-content: flex-end;
  margin-right: auto;
  margin-left: 0;
}

.inline-icon {
  display: inline-flex;
  vertical-align: top;
  font-size: 28px !important;
}

.loading-state {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.grid-containerP {
  max-width: 990px;
  display: grid;
  grid-gap: 1px;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
}

.wrapper {
  position: relative;
}

.myLayer {
  position: absolute;
  /* becomes a layer */
  // left: 0;
  /* relative to its parent wrapper */
  top: -18px;
  right: -23px;
  /* relative to its parent wrapper */
  z-index: 2;
  font-size: 20px;
}
</style>
